import en from "../../i18n/en";
import pl from "../../i18n/pl";

// ==================== Шаблоны визуализации ====================
const S3_BASE_URL = "https://s3.twcstorage.ru/1069577a-d68b-409d-9398-fef1c9cce817";

function getWebsiteInfo(result) {
  const wi = result?.raw_data?.website_info;
  return Array.isArray(wi) ? wi : [];
}

function collectWebsiteEmails(sites) {
  const all = new Set();
  sites.forEach((s) => {
    const emails = s?.raw_data?.emails;
    if (Array.isArray(emails)) emails.forEach((e) => all.add(e));
  });
  return [...all];
}

function websiteHasPlatform(sites, platform) {
  return sites.some((s) => {
    const sm = s?.raw_data?.social_media;
    return Array.isArray(sm) && sm.some((x) => x.platform === platform);
  });
}

function anyWebsiteFlag(sites, flag) {
  return sites.some((s) => s?.raw_data?.[flag] === true);
}


export function getVisualizationTemplates(lang) {
  const t = lang === "pl" ? pl : en;

  return {
    instagram_posts: {
      title: t.visualizationTemplate.instagramPost,
      aiVariables: [
        { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, getValue: (result) => result.raw_data?.profile_info?.username || result.raw_data?.username || "N/A" },
        { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, getValue: (result) => result.raw_data?.text || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
        
      ],
      basicFilters : [

         { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, type: "text" },
        { key: "TEXT", label: t.visualizationTemplate.textInstagramPost,   type: "text"   },
        { key: "LIKES", label: t.visualizationTemplate.likes, type: "number"   },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, type: "number"   },
        

        
      ],

  

      sections: [



        { type: "text", key: "text", label: t.visualizationTemplate.caption, getValue: (result) => result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image_url", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.image_url, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "❤️" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
        ]},
        { type: "author_link", label: t.visualizationTemplate.author, getValue: (result) => {
          const username = result.raw_data?.profile_info?.username || result.raw_data?.username;
          if (!username) return null;
          return { username: `@${username}`, url: `https://instagram.com/${username}`, icon: "👤" };
        }},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    instagram_pages: {
      title: t.visualizationTemplate.instagramPage,
      aiVariables: [
        { key: "USERNAME", label: t.visualizationTemplate.instagram_profile_username, getValue: (result) => result.raw_data?.username || "N/A" },
        { key: "BIO", label: t.visualizationTemplate.instagram_profile_bio, getValue: (result) => result.raw_data?.bio || "N/A" },
        { key: "FOLLOWERS", label: t.visualizationTemplate.instagram_profile_followers, getValue: (result) => String(result.raw_data?.followers || "N/A") },
        { key: "FOLLOWING", label: t.visualizationTemplate.instagram_profile_following, getValue: (result) => String(result.raw_data?.followees || "N/A") },
        { key: "MEDIACOUNT", label: t.visualizationTemplate.instagram_profile_posts, getValue: (result) => String(result.raw_data?.mediacount || "N/A") },
        { key: "FULLNAME", label: t.visualizationTemplate.instagram_profile_fullname, getValue: (result) => String(result.raw_data?.full_name || "N/A") },
        
      ],
      basicFilters : [

         { key: "USERNAME", label: t.visualizationTemplate.instagram_profile_username, type: "text" },
        { key: "BIO",   label: t.visualizationTemplate.instagram_profile_bio, type: "text"   },
        { key: "FOLLOWERS", label: t.visualizationTemplate.instagram_profile_followers, type: "number"   },
        { key: "FOLLOWING", label: t.visualizationTemplate.instagram_profile_following, type: "number"   },
        { key: "MEDIACOUNT", label: t.visualizationTemplate.instagram_profile_posts,  type: "number"  },
        
      ],

      sections: [



        { type: "text", key: "bio", label: t.visualizationTemplate.bio, getValue: (result) => result.raw_data?.bio, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap" } },
        { type: "profile_header", label: t.visualizationTemplate.profile, getValue: (result) => {
          const username = result.raw_data?.username;
          return { username, url: `https://instagram.com/${username}`, full_name: result.raw_data?.full_name, profile_pic_url: result.raw_data?.profile_pic_url };
        }},
        { type: "stats", label: t.visualizationTemplate.pageStats, items: [
          { key: "followers", label: t.visualizationTemplate.followers, getValue: (result) => result.raw_data?.followers?.toLocaleString() || "N/A", icon: "👥" },
          { key: "following", label: t.visualizationTemplate.following, getValue: (result) => result.raw_data?.followees?.toLocaleString() || "N/A", icon: "👣" },
          { key: "posts", label: t.visualizationTemplate.posts, getValue: (result) => result.raw_data?.mediacount?.toLocaleString() || "N/A", icon: "📝" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
        { type: "meta", label: t.visualizationTemplate.details, items: [
          { key: "url", label: t.visualizationTemplate.pageUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    facebook_posts: {
      title: t.visualizationTemplate.facebookPost,
      aiVariables: [
        { key: "TEXT", label: t.visualizationTemplate.facebook_post_text, getValue: (result) => result.raw_data?.description || result.raw_data?.text || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
        
      ],
      basicFilters: [
        { key: "TEXT", label: t.visualizationTemplate.facebook_post_text, type: "text"  },
        { key: "LIKES", label: t.visualizationTemplate.likes,  type: "number" },
        { key: "COMMENTS", label: t.visualizationTemplate.comments,  type: "number" },
      
      ],
      
      sections: [


        { type: "text", key: "description", label: t.visualizationTemplate.postContent, getValue: (result) => result.raw_data?.description || result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image_url", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.image_url, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "👍" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    linkedin_posts: {
      title: t.visualizationTemplate.linkedinPost,
      aiVariables: [
        { key: "AUTHOR", label: t.visualizationTemplate.linkedin_post_author, getValue: (result) => result.raw_data?.post?.author?.name || "N/A" },
        { key: "HEADLINE", label: t.visualizationTemplate.linkedin_post_headline, getValue: (result) => result.raw_data?.post?.headline || "N/A" },
        { key: "TEXT", label: t.visualizationTemplate.linkedin_post_content, getValue: (result) => result.raw_data?.post?.articleBody || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.post?.engagement?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.post?.engagement?.comments || 0) },
        { key: "SHARES", label: t.visualizationTemplate.linkedin_post_shares, getValue: (result) => String(result.raw_data?.post?.engagement?.shares || 0) },
      ],

      basicFilters: [
        { key: "AUTHOR", label: t.visualizationTemplate.linkedin_post_author,  type:"text" },
        { key: "HEADLINE", label: t.visualizationTemplate.linkedin_post_headline,  type:"text"   },
        { key: "TEXT", label: t.visualizationTemplate.linkedin_post_content,  type:"text"   },
        { key: "LIKES", label: t.visualizationTemplate.likes, type:"number"   },
        { key: "COMMENTS", label: t.visualizationTemplate.comments,  type:"number" },
        { key: "SHARES", label: t.visualizationTemplate.linkedin_post_shares,  type:"number"},
      ],


      sections: [
        

        { type: "text", key: "headline", label: t.visualizationTemplate.headline, getValue: (result) => result.raw_data?.post?.headline, style: { fontSize: 16, fontWeight: 600, lineHeight: 1.4, marginBottom: 8 } },
        { type: "text", key: "articleBody", label: t.visualizationTemplate.postContent, getValue: (result) => result.raw_data?.post?.articleBody, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.post?.image, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "profile_header", label: t.visualizationTemplate.author, getValue: (result) => {
          const author = result.raw_data?.post?.author;
          if (!author) return null;
          return { username: author.name, url: author.url, full_name: author.name, profile_pic_url: author.profileImage, subtitle: author.followers ? `${author.followers.toLocaleString()} ${t.visualizationTemplate.followers}` : null };
        }},
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.post?.engagement?.likes?.toLocaleString() || "0", icon: "👍" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.post?.engagement?.comments?.toLocaleString() || "0", icon: "💬" },
          { key: "shares", label: t.visualizationTemplate.shares, getValue: (result) => result.raw_data?.post?.engagement?.shares?.toLocaleString() || "0", icon: "🔄" },
        ]},
        { type: "meta", label: t.visualizationTemplate.published, items: [
          { key: "datePublished", label: t.visualizationTemplate.date, getValue: (result) => result.raw_data?.post?.datePublished ? formatDate(result.raw_data.post.datePublished) : null, icon: "📅" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    facebook_pages: {
      title: t.visualizationTemplate.facebookPage,
      aiVariables: [
        { key: "NAME", label: t.visualizationTemplate.facebook_page_name, getValue: (result) => result.raw_data?.name || "N/A" },
        { key: "STATUS", label: t.visualizationTemplate.facebook_page_description, getValue: (result) => result.raw_data?.status || t.visualizationTemplate.noDescription },
       
        { key: "FOLLOWERS", label: t.visualizationTemplate.followers, getValue: (result) => String(result.raw_data?.followers || "N/A") },
        { key: "FOLLOWING", label: t.visualizationTemplate.following, getValue: (result) => String(result.raw_data?.following || "N/A") },
        { key: "EMAIL", label: t.visualizationTemplate.email, getValue: (result) => result.raw_data?.contact_info?.email || "N/A" },
        { key: "PHONE", label: t.visualizationTemplate.phone, getValue: (result) => result.raw_data?.contact_info?.phone || "N/A" },
        { key: "WEBSITE", label: t.visualizationTemplate.website, getValue: (result) => result.raw_data?.contact_info?.website || "N/A" },
        
      ],
      basicFilters: [
          { key: "NAME", label: t.visualizationTemplate.facebook_page_name,  type:"text" },
        { key: "STATUS", label: t.visualizationTemplate.facebook_page_description, type:"text"  },
       
        { key: "FOLLOWERS", label: t.visualizationTemplate.followers, type:"number" },
        { key: "FOLLOWING", label: t.visualizationTemplate.following,  type:"number" },
        { key: "EMAIL", label: t.visualizationTemplate.email, type:"text"  },
        { key: "PHONE", label: t.visualizationTemplate.phone, type:"text"  },
        { key: "WEBSITE", label: t.visualizationTemplate.website,  type:"text"  },
        { key: "HAS_PHONE", label: t.visualizationTemplate.hasPhone, type:"bool"  },
        { key: "HAS_EMAIL", label: t.visualizationTemplate.hasEmail, type:"bool"  },
      ],
      sections: [
        

        { type: "text", key: "status", label: t.visualizationTemplate.description, getValue: (result) => result.raw_data?.status || null, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap" } },
        { type: "profile_header", label: t.visualizationTemplate.profile, getValue: (result) => {
          const name = result.raw_data?.name;
          if (!name) return null;
          return { username: name, url: result.url || result.raw_data?.profile_url, full_name: name, profile_pic_url: result.raw_data?.avatar_url };
        }},
        { type: "text", key: "category", label: t.visualizationTemplate.category, getValue: (result) => result.raw_data?.category },
        { type: "stats", label: t.visualizationTemplate.pageStats, items: [
          { key: "followers", label: t.visualizationTemplate.followers, getValue: (result) => result.raw_data?.followers?.toLocaleString() || "0", icon: "👥" },
          { key: "following", label: t.visualizationTemplate.following, getValue: (result) => result.raw_data?.following?.toLocaleString() || "0", icon: "👣" },
        ]},
        { type: "meta", label: t.visualizationTemplate.contactInfo, items: [
          { key: "phone", label: t.visualizationTemplate.phone, getValue: (result) => result.raw_data?.contact_info?.phone, icon: "📞" },
          { key: "email", label: t.visualizationTemplate.email, getValue: (result) => result.raw_data?.contact_info?.email, icon: "✉️" },
          { key: "website", label: t.visualizationTemplate.website, getValue: (result) => result.raw_data?.contact_info?.website, isLink: true, icon: "🌐" },
          { key: "address", label: t.visualizationTemplate.address, getValue: (result) => result.raw_data?.contact_info?.address, icon: "📍" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.details, items: [
          { key: "url", label: t.visualizationTemplate.pageUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "scraped_url", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source?.scraped_url, isLink: true, icon: "🔍" },
          { key: "keyword", label: t.visualizationTemplate.keyword, getValue: (result) => result.source?.keyword, icon: "🔑" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    // Внутри getVisualizationTemplates, перед default:
instagram_reels: {
  title: t.visualizationTemplate.instagramReel || "Instagram Reel",
  aiVariables: [
    { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, getValue: (result) => result.raw_data?.profile_info?.username || result.raw_data?.username || "N/A" },
    { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, getValue: (result) => result.raw_data?.text || "N/A" },
    { key: "VIDEO", label: t.visualizationTemplate.videoUrl || "Video URL", getValue: (result) => result.raw_data?.video_url || result.raw_data?.url || "N/A" },
    { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
    { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
    { key: "VIEWS", label: t.visualizationTemplate.views || "Views", getValue: (result) => String(result.raw_data?.views || 0) },
  ],
  basicFilters: [
    { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, type: "text" },
    { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, type: "text" },
    { key: "LIKES", label: t.visualizationTemplate.likes, type: "number" },
    { key: "COMMENTS", label: t.visualizationTemplate.comments, type: "number" },
    { key: "VIEWS", label: t.visualizationTemplate.views || "Views", type: "number" },
  ],
  sections: [

    { type: "text", key: "text", label: t.visualizationTemplate.caption, getValue: (result) => result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
    { type: "video", key: "video_url", label: t.visualizationTemplate.video || "Video", getValue: (result) => result.raw_data?.video_url || result.url, style: { maxHeight: 400, borderRadius: 12, background: "#000" } },
    { type: "stats", label: t.visualizationTemplate.engagement, items: [
      { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "❤️" },
      { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
      { key: "views", label: t.visualizationTemplate.views || "Views", getValue: (result) => result.raw_data?.views?.toLocaleString() || "0", icon: "👁" },
    ]},
    { type: "author_link", label: t.visualizationTemplate.author, getValue: (result) => {
      const username = result.raw_data?.profile_info?.username || result.raw_data?.username;
      if (!username) return null;
      return { username: `@${username}`, url: `https://instagram.com/${username}`, icon: "👤" };
    }},
    { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
    { type: "meta", label: t.visualizationTemplate.postInfo, items: [
      { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
      { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
    ]}
  ]
},



 instagram_adb_old: {
  title: 'Instagram ADB',
  aiVariables: [
    { key: "COUNTRY", label: "Country", getValue: (result) => result.raw_data?.country || "N/A" },
    { key: "USERNAME", label: "Username", getValue: (result) => result.raw_data?.username || "N/A" },
    { key: "FULL_NAME", label: "Full Name", getValue: (result) => result.raw_data?.full_name || "N/A" },
    { key: "BIO", label: "Bio", getValue: (result) => result.raw_data?.bio || "N/A" },
    { key: "EMAIL", label: "Email", getValue: (result) => result.raw_data?.email || "N/A" },
    { key: "FOLLOWERS", label: "Followers", getValue: (result) => String(result.raw_data?.followers || "0") },
    { key: "FOLLOWING", label: "Following", getValue: (result) => String(result.raw_data?.following || "0") },
    { key: "MEDIACOUNT", label: "Posts", getValue: (result) => String(result.raw_data?.mediacount || "0") },
    { key: "LINKS", label: "Links", getValue: (result) => {
      const links = result.raw_data?.links;
      return Array.isArray(links) ? links.join(', ') : "N/A";
    }},
    { key: "SCREENSHOT", label: "Screenshot", getValue: (result) => result.raw_data?.screenshot_url || "N/A" },
            // ─── WEBSITE INFO (полная копия dns_resolving.aiVariables) ──────
        { key: "WEBSITE_URL", label: "Website URL",
          getValue: (result) => getWebsiteInfo(result)[0]?.url || null },
        { key: "WEBSITE_FINAL_URL", label: "Website Final URL",
          getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.final_url || null },
        { key: "WEBSITE_TITLE", label: "Website Title",
          getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.title || null },
        { key: "WEBSITE_DESCRIPTION", label: "Website Description",
          getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.description || null },
        { key: "WEBSITE_STATUS", label: "Website Status",
          getValue: (result) => getWebsiteInfo(result)[0]?.status || null },
        { key: "WEBSITE_MATCHED_RULE", label: "Website Matched Rule",
          getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.dns?.matched_rule || null },
        { key: "WEBSITE_EMAILS", label: "Website Emails",
          getValue: (result) => {
            const emails = collectWebsiteEmails(getWebsiteInfo(result));
            return emails.length ? emails.join(", ") : null;
          } },
        { key: "HAS_WEBSITE_EMAIL", label: "Has Website Email",
          getValue: (result) => String(collectWebsiteEmails(getWebsiteInfo(result)).length > 0) },
        { key: "WEBSITE_HAS_SPA", label: "Website Has SPA",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "has_spa")) },
        { key: "WEBSITE_HAS_CONTACT_FORM", label: "Website Has Contact Form",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "has_contact_form")) },
        { key: "WEBSITE_EMAIL_PROTECTED", label: "Website Email Protected",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "email_protected")) },
        { key: "WEBSITE_CAPTCHA_DETECTED", label: "Website Captcha Detected",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "captcha_detected")) },
        { key: "WEBSITE_CALENDLY_FOUND", label: "Website Calendly Found",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "calendly_found")) },
        { key: "WEBSITE_GOOGLE_FORMS_FOUND", label: "Website Google Forms",
          getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "google_forms_found")) },
        { key: "WEBSITE_SOCIAL_COUNT", label: "Website Social Links",
          getValue: (result) => {
            const sites = getWebsiteInfo(result);
            const total = sites.reduce((acc, s) => {
              const sm = s?.raw_data?.social_media;
              return acc + (Array.isArray(sm) ? sm.length : 0);
            }, 0);
            return String(total);
          } },
        { key: "HAS_WEBSITE_FACEBOOK", label: "Has Website Facebook",
          getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "facebook")) },
        { key: "HAS_WEBSITE_INSTAGRAM", label: "Has Website Instagram",
          getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "instagram")) },
        { key: "HAS_WEBSITE_TWITTER", label: "Has Website Twitter",
          getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "twitter")) },
        { key: "HAS_WEBSITE_LINKEDIN", label: "Has Website LinkedIn",
          getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "linkedin")) },
        { key: "HAS_WEBSITE_YOUTUBE", label: "Has Website YouTube",
          getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "youtube")) },
        { key: "WEBSITE_TEXT_33", label: "Website Text (33%)",
          getValue: (result) => {
            const sites = getWebsiteInfo(result);
            if (!sites.length) return null;
            const txt = sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || "";
            if (!txt) return null;
            return txt.slice(0, Math.floor(txt.length * 0.33));
          } },
        { key: "WEBSITE_TEXT_66", label: "Website Text (66%)",
          getValue: (result) => {
            const sites = getWebsiteInfo(result);
            if (!sites.length) return null;
            const txt = sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || "";
            if (!txt) return null;
            return txt.slice(0, Math.floor(txt.length * 0.66));
          } },
        { key: "WEBSITE_TEXT", label: "Website Full Text",
          getValue: (result) => {
            const sites = getWebsiteInfo(result);
            if (!sites.length) return null;
            return sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || null;
          } },

  ],

  basicFilters: [
    { key: "COUNTRY", label: "Country", type: "text" },
    { key: "USERNAME", label: "Username", type: "text" },
    { key: "FULL_NAME", label: "Full Name", type: "text" },
    { key: "BIO", label: "Bio", type: "text" },
    { key: "EMAIL", label: "Email", type: "text" },
    { key: "FOLLOWERS", label: "Followers", type: "number" },
    { key: "FOLLOWING", label: "Following", type: "number" },
    { key: "MEDIACOUNT", label: "Posts", type: "number" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_LINKS", label: "Has Links", type: "bool" },
    { key: "HAS_SCREENSHOT", label: "Has Screenshot", type: "bool" },


    {
      key: "LAST_POST_DATE",
      label: "Last post date",   // we'll add this translation key
      type: "date"
    },
            // ─── WEBSITE INFO (полная копия dns_resolving.basicFilters) ─────
        { key: "WEBSITE_URL", label: "Website URL", type: "text" },
        { key: "WEBSITE_TITLE", label: "Website Title", type: "text" },
        { key: "WEBSITE_DESCRIPTION", label: "Website Description", type: "text" },
        { key: "WEBSITE_TEXT", label: "Website Text", type: "text" },
        { key: "WEBSITE_MATCHED_RULE", label: "Website Matched Rule", type: "text" },
        { key: "WEBSITE_EMAIL", label: "Website Email", type: "text" },
        { key: "HAS_WEBSITE_REDIRECT", label: "Website Has Redirect", type: "bool" },
        { key: "HAS_WEBSITE_EMAIL", label: "Website Has Email", type: "bool" },
        { key: "WEBSITE_HAS_SPA", label: "Website Has SPA", type: "bool" },
        { key: "WEBSITE_HAS_CONTACT_FORM", label: "Website Has Contact Form", type: "bool" },
        { key: "WEBSITE_EMAIL_PROTECTED", label: "Website Email Protected", type: "bool" },
        { key: "WEBSITE_CAPTCHA_DETECTED", label: "Website Captcha Detected", type: "bool" },
        { key: "WEBSITE_CALENDLY_FOUND", label: "Website Calendly Found", type: "bool" },
        { key: "WEBSITE_GOOGLE_FORMS_FOUND", label: "Website Google Forms Found", type: "bool" },
        { key: "HAS_WEBSITE_FACEBOOK", label: "Website Has Facebook", type: "bool" },
        { key: "HAS_WEBSITE_INSTAGRAM", label: "Website Has Instagram", type: "bool" },
        { key: "HAS_WEBSITE_TWITTER", label: "Website Has Twitter", type: "bool" },
        { key: "HAS_WEBSITE_LINKEDIN", label: "Website Has LinkedIn", type: "bool" },
        { key: "HAS_WEBSITE_YOUTUBE", label: "Website Has YouTube", type: "bool" },
  ],

  sections: [
    // Profile Header
   

    { 
      type: "profile_header", 
      label: "Profile", 
      getValue: (result) => {
        const username = result.raw_data?.username;
        if (!username) return null;
        return {
          username: `${username}`,
          url: `https://instagram.com/${username}`,
          full_name: result.raw_data?.full_name,
          profile_pic_url: null
        };
      }
    },
    
    // Bio
    { 
      type: "text", 
      key: "bio", 
      label: 'Bio', 
      getValue: (result) => result.raw_data?.bio, 
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto" 
      } 
    },
    
    // Email
    { 
      type: "text", 
      key: "email", 
      label: 'Email', 
      getValue: (result) => {
        const email = result.raw_data?.email;
        return email || null;
      },
      style: { 
        fontSize: 14, 
        lineHeight: 1.7 
      } 
    },
    
    // Links - ВСЕ ССЫЛКИ В СТОЛБИК (кликабельные)
    {
      type: "custom",
      key: "links",
      label: 'Links',
      render: (result) => {
        const links = result.raw_data?.links;
        
        // Проверяем, что links существует и это массив
        if (!Array.isArray(links) || links.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No links available
            </div>
          );
        }
        
        // Показываем ВСЕ ссылки в столбик
        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {links.map((link, index) => {
              // Добавляем https:// если ссылка без протокола
              const href = link.startsWith('http') ? link : `https://${link}`;
              return (
                <div 
                  key={index} 
                  style={{ 
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  <a 
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: '#1890ff',
                      textDecoration: 'none',
                      wordBreak: 'break-all',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.textDecoration = 'underline';
                      e.target.style.color = '#40a9ff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.textDecoration = 'none';
                      e.target.style.color = '#1890ff';
                    }}
                  >
                    🔗 {link}
                  </a>
                </div>
              );
            })}
          </div>
        );
      }
    },
    
    {
      type: "custom",
      key: "latest_posts",
      label: 'Latest posts',
      render: (result) => {
        const latest_posts = result.raw_data?.latest_posts;
        
        // Проверяем, что links существует и это массив
        if (!Array.isArray(latest_posts) || latest_posts.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No posts available
            </div>
          );
        }
        
        // Показываем ВСЕ ссылки в столбик
        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {latest_posts.map((post, index) => {
              // Добавляем https:// если ссылка без протокола
              

              return (
                <div 
                  key={index} 
                  style={{ 
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  {post}
                </div>
              );
            })}
          </div>
        );
      }
    },

    // Stats
    { 
      type: "stats", 
      label: "Page Stats", 
      items: [
        { 
          key: "followers", 
          label: "Followers", 
          getValue: (result) => result.raw_data?.followers?.toLocaleString() || "0", 
          icon: "👥" 
        },
        { 
          key: "following", 
          label: "Following", 
          getValue: (result) => result.raw_data?.following?.toLocaleString() || "0", 
          icon: "👣" 
        },
        { 
          key: "posts", 
          label: "Posts", 
          getValue: (result) => result.raw_data?.mediacount?.toLocaleString() || "0", 
          icon: "📝" 
        },
      ]
    },
    
    // Country
    { 
      type: "meta", 
      label: "Location", 
      items: [
        { 
          key: "country", 
          label: "Country", 
          getValue: (result) => result.raw_data?.country, 
          icon: "🌍" 
        },
      ]
    },


            // ─── Website Info: полная копия dns_resolving.sections ──────────
        {
          type: "custom",
          key: "website_info",
          label: "Websites",
          hideWhenEmpty: true,
          render: (result) => {
            const sites = getWebsiteInfo(result);
            if (!sites.length) return null;

            return (
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                {sites.map((site, idx) => {
                  const r = site.raw_data || {};
                  const emails = Array.isArray(r.emails) ? r.emails : [];
                  const socials = Array.isArray(r.social_media) ? r.social_media : [];
                  const captchaTypes = Array.isArray(r.captcha_types) ? r.captcha_types : [];
                  const spaReasons = Array.isArray(r.spa_reasons) ? r.spa_reasons : [];
                  const fetchErrors = Array.isArray(r.fetch_errors) ? r.fetch_errors : [];
                  const checkedPages = Array.isArray(r.checked_pages) ? r.checked_pages : [];

                  const domain = r.dns?.domain
                    || (site.url || "").replace(/^https?:\/\//, "").split("/")[0];

                  const hasPlatform = (p) => socials.some((s) => s.platform === p);

                  const flags = [
                    { label: "Has Email", value: emails.length > 0, icon: "✉️" },
                    { label: "SPA", value: r.has_spa, icon: "⚡" },
                    { label: "Contact Form", value: r.has_contact_form, icon: "📝" },
                    { label: "Email Protected", value: r.email_protected, icon: "🔒" },
                    { label: "Captcha Detected", value: r.captcha_detected, icon: "🤖" },
                    { label: "Calendly Found", value: r.calendly_found, icon: "📅" },
                    { label: "Google Forms", value: r.google_forms_found, icon: "📋" },
                    { label: "Facebook", value: hasPlatform("facebook"), icon: "📘" },
                    { label: "Instagram", value: hasPlatform("instagram"), icon: "📷" },
                    { label: "Twitter", value: hasPlatform("twitter"), icon: "🐦" },
                    { label: "LinkedIn", value: hasPlatform("linkedin"), icon: "💼" },
                    { label: "YouTube", value: hasPlatform("youtube"), icon: "▶️" },
                  ].filter((f) => f.value !== undefined && f.value !== null);

                  const textKey = r.main_page_text_key;
                  const fallbackText = r.main_page_text || r.text;

                  // группировка social по платформе
                  const groupedSocials = {};
                  socials.forEach((s) => {
                    if (!groupedSocials[s.platform]) groupedSocials[s.platform] = new Set();
                    groupedSocials[s.platform].add(s.url);
                  });
                  const socialIcons = {
                    facebook: "📘",
                    instagram: "📷",
                    twitter: "🐦",
                    linkedin: "💼",
                    youtube: "▶️",
                  };

                  return (
                    <div
                      key={idx}
                      style={{
                        marginBottom: 18,
                        padding: "12px 14px",
                        border: "1px solid #d1d5db",
                        borderRadius: 10,
                        background: "#ffffff",
                      }}
                    >
                      {/* ─── Site header (domain + status) ──────────────── */}
                      <div
                        style={{
                          marginBottom: 10,
                          paddingBottom: 8,
                          borderBottom: "1px solid #e5e7eb",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 6,
                        }}
                      >
                        <a
                          href={r.final_url || site.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#1890ff",
                            textDecoration: "none",
                            fontWeight: 700,
                            fontSize: 15,
                            wordBreak: "break-all",
                          }}
                        >
                          🌐 {domain || site.url}
                        </a>
                        <span
                          style={{
                            padding: "2px 10px",
                            borderRadius: 10,
                            fontSize: 11,
                            background: site.status === "success" ? "#dcfce7" : "#fef3c7",
                            color: site.status === "success" ? "#166534" : "#92400e",
                          }}
                        >
                          {site.status || "unknown"}
                        </span>
                      </div>

                      {/* ─── Profile header (title + final url) ────────── */}
                      <div style={{ marginBottom: 10 }}>
                        {r.title && (
                          <div style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                            {r.title}
                          </div>
                        )}
                        {r.final_url && (
                          <div style={{ marginTop: 4 }}>
                            <a
                              href={r.final_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1890ff",
                                textDecoration: "none",
                                fontSize: 12,
                                wordBreak: "break-all",
                              }}
                            >
                              🔗 {r.final_url}
                            </a>
                          </div>
                        )}
                      </div>

                      {/* ─── Title section ────────────────────────────── */}
                      {r.title && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Title
                          </div>
                          <div style={{
                            fontSize: 13,
                            lineHeight: 1.7,
                            whiteSpace: "pre-wrap",
                            maxHeight: 300,
                            overflowY: "auto",
                            background: "#f9fafb",
                            padding: "8px 10px",
                            borderRadius: 6,
                          }}>
                            {r.title}
                          </div>
                        </div>
                      )}

                      {/* ─── Description section ──────────────────────── */}
                      {r.description && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Description
                          </div>
                          <div style={{
                            fontSize: 13,
                            lineHeight: 1.7,
                            whiteSpace: "pre-wrap",
                            maxHeight: 300,
                            overflowY: "auto",
                            background: "#f9fafb",
                            padding: "8px 10px",
                            borderRadius: 6,
                          }}>
                            {r.description}
                          </div>
                        </div>
                      )}

                      {/* ─── Website Text (S3 link or fallback) ───────── */}
                      {(textKey || fallbackText) && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Website Text
                          </div>
                          {textKey ? (
                            <a
                              href={`${S3_BASE_URL}/${textKey}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                padding: "6px 12px",
                                border: "1.5px solid #1890ff",
                                borderRadius: 8,
                                color: "#1890ff",
                                textDecoration: "none",
                                fontWeight: 600,
                                fontSize: 12,
                              }}
                            >
                              📄 Open Website Text
                            </a>
                          ) : (
                            <div style={{
                              fontSize: 13,
                              lineHeight: 1.7,
                              whiteSpace: "pre-wrap",
                              maxHeight: 400,
                              overflowY: "auto",
                              background: "#fafafa",
                              padding: "8px 12px",
                              borderRadius: 8,
                            }}>
                              {fallbackText}
                            </div>
                          )}
                        </div>
                      )}

                      {/* ─── Matched Rule ────────────────────────────── */}
                      {r.dns?.matched_rule && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Matched Rule
                          </div>
                          <div style={{
                            fontSize: 13,
                            lineHeight: 1.7,
                            whiteSpace: "pre-wrap",
                            background: "#f0fdf4",
                            padding: "8px 12px",
                            borderRadius: 8,
                            color: "#065f46",
                          }}>
                            {r.dns.matched_rule}
                          </div>
                        </div>
                      )}

                      {/* ─── Emails ──────────────────────────────────── */}
                      {emails.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Emails ({emails.length})
                          </div>
                          <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                            {emails.map((email, i) => (
                              <div key={i} style={{ marginBottom: 4 }}>
                                <a
                                  href={`mailto:${email}`}
                                  style={{ color: "#1890ff", textDecoration: "none" }}
                                >
                                  ✉️ {email}
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ─── Social Media (grouped) ───────────────────── */}
                      {socials.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Social Media
                          </div>
                          <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                            {Object.entries(groupedSocials).map(([platform, urls]) => (
                              <div key={platform} style={{ marginBottom: 8 }}>
                                <div style={{ fontWeight: 600, marginBottom: 3, color: "#4b5563", fontSize: 12 }}>
                                  {socialIcons[platform] || "🔗"} {platform} ({urls.size})
                                </div>
                                {[...urls].map((url, i) => (
                                  <div key={i} style={{ marginLeft: 16, marginBottom: 2 }}>
                                    <a
                                      href={url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#1890ff",
                                        textDecoration: "none",
                                        wordBreak: "break-all",
                                        fontSize: 12,
                                      }}
                                    >
                                      {url}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ─── Detection Flags ─────────────────────────── */}
                      {flags.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Detection Flags
                          </div>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {flags.map((f) => (
                              <span
                                key={f.label}
                                style={{
                                  padding: "3px 9px",
                                  borderRadius: 12,
                                  fontSize: 11,
                                  background: f.value ? "#dcfce7" : "#f3f4f6",
                                  color: f.value ? "#166534" : "#6b7280",
                                  border: `1px solid ${f.value ? "#86efac" : "#e5e7eb"}`,
                                }}
                              >
                                {f.icon} {f.label}: {f.value ? "Yes" : "No"}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ─── Captcha Types ───────────────────────────── */}
                      {captchaTypes.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Captcha Types
                          </div>
                          <div style={{ fontSize: 13, lineHeight: 1.7, color: "#4b5563" }}>
                            {captchaTypes.join(", ")}
                          </div>
                        </div>
                      )}

                      {/* ─── SPA Reasons ─────────────────────────────── */}
                      {spaReasons.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            SPA Reasons
                          </div>
                          <div style={{ fontSize: 13, lineHeight: 1.7, color: "#4b5563" }}>
                            {spaReasons.join(", ")}
                          </div>
                        </div>
                      )}

                      {/* ─── Fetch Errors ────────────────────────────── */}
                      {fetchErrors.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Fetch Errors
                          </div>
                          <div style={{
                            fontSize: 12,
                            lineHeight: 1.6,
                            color: "#b91c1c",
                            whiteSpace: "pre-wrap",
                            background: "#fef2f2",
                            padding: "6px 10px",
                            borderRadius: 6,
                          }}>
                            {fetchErrors.map((e, i) => (
                              <div key={i}>{typeof e === "string" ? e : JSON.stringify(e)}</div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ─── Website Text (full, fallback if no S3) ──── */}
                      {!textKey && fallbackText && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Website Text (full)
                          </div>
                          <div style={{
                            fontSize: 12,
                            lineHeight: 1.7,
                            whiteSpace: "pre-wrap",
                            maxHeight: 400,
                            overflowY: "auto",
                            background: "#fafafa",
                            padding: "8px 12px",
                            borderRadius: 8,
                          }}>
                            {fallbackText}
                          </div>
                        </div>
                      )}

                      {/* ─── Checked Pages ───────────────────────────── */}
                      {checkedPages.length > 0 && (
                        <div style={{ marginBottom: 8 }}>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Checked Pages ({checkedPages.length})
                          </div>
                          <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                            {checkedPages.map((p, i) => (
                              <div key={i} style={{ marginBottom: 2 }}>
                                <a
                                  href={p}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                                >
                                  🔍 {p}
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ─── Details (meta) ──────────────────────────── */}
                      <div style={{ marginBottom: 6 }}>
                        <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                          Details
                        </div>
                        <div style={{ fontSize: 12, lineHeight: 1.7, color: "#4b5563" }}>
                          {r.worker && (
                            <div>⚙️ Worker: {r.worker}</div>
                          )}
                          {r.root_url && (
                            <div>
                              🔗 Root URL:{" "}
                              <a
                                href={r.root_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                              >
                                {r.root_url}
                              </a>
                            </div>
                          )}
                          {r.final_url && (
                            <div>
                              🔗 Final URL:{" "}
                              <a
                                href={r.final_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                              >
                                {r.final_url}
                              </a>
                            </div>
                          )}
                          {r.timestamp && (
                            <div>🕒 Scraped At: {formatDate(r.timestamp)}</div>
                          )}
                          {site.url && (
                            <div>
                              🌐 URL:{" "}
                              <a
                                href={site.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                              >
                                {site.url}
                              </a>
                            </div>
                          )}
                          {site.completed_at && (
                            <div>📅 Completed: {formatDate(site.completed_at)}</div>
                          )}
                        </div>
                      </div>

                      {/* ─── Source (meta) ───────────────────────────── */}
                      {(site.source || r.source) && (
                        <div>
                          <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                            Source
                          </div>
                          <div style={{ fontSize: 12, lineHeight: 1.7, color: "#4b5563" }}>
                            {(site.source?.scraped_url || r.source?.scraped_url) && (
                              <div>
                                🔍 Scraped URL:{" "}
                                <a
                                  href={site.source?.scraped_url || r.source?.scraped_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                                >
                                  {site.source?.scraped_url || r.source?.scraped_url}
                                </a>
                              </div>
                            )}
                            {(site.source?.keyword || r.source?.keyword) && (
                              <div>🔑 Keyword: {site.source?.keyword || r.source?.keyword}</div>
                            )}
                            {(site.source?.search_position || r.source?.search_position) && (
                              <div>📍 Position: {site.source?.search_position || r.source?.search_position}</div>
                            )}
                            {(site.source?.search_page || r.source?.search_page) && (
                              <div>📄 Search Page: {site.source?.search_page || r.source?.search_page}</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          },
        },

    
    // Screenshot
    { 
      type: "image", 
      key: "screenshot_url", 
      label: "Screenshot", 
      getValue: (result) => "https://flautreach.com/media/" + result.raw_data?.screenshot_url,
      style: { 
        maxHeight: 500, 
        objectFit: "contain", 
        borderRadius: 12, 
        background: "#f5f5f5" 
      } 
    },
    
    // Meta
    { 
      type: "meta", 
      label: "Details", 
      items: [
        { 
          key: "url", 
          label: "Instagram URL", 
          getValue: (result) => result.url, 
          isLink: true, 
          icon: "🔗" 
        },
        { 
          key: "created_at", 
          label: "Scraped", 
          getValue: (result) => formatDate(result.created_at), 
          icon: "📅" 
        },
      ]
    }




  ]
},

  facebook_screenshot: {
  title: 'Facebook Screenshot',
  aiVariables: [
    { key: "NAME", label: "Page Name", getValue: (result) => result.raw_data?.name || "N/A" },
    { key: "STATUS_TEXT", label: "Status", getValue: (result) => result.raw_data?.status_text || "N/A" },
    { key: "COUNTRY", label: "Country", getValue: (result) => result.raw_data?.country || "N/A" },
    { key: "EMAIL", label: "Email", getValue: (result) => result.raw_data?.email || "N/A" },
    { key: "PHONE", label: "Phone", getValue: (result) => result.raw_data?.phone || "N/A" },
    { key: "WEBSITE", label: "Website", getValue: (result) => result.raw_data?.website || "N/A" },
    { key: "ADDRESS", label: "Address", getValue: (result) => result.raw_data?.address || "N/A" },
    { key: "FOLLOWERS", label: "Followers", getValue: (result) => String(result.raw_data?.followers || "0") },
    { key: "FOLLOWING", label: "Following", getValue: (result) => String(result.raw_data?.following || "0") },
    { key: "RAW_RESPONSE", label: "AI Response", getValue: (result) => result.raw_data?.raw_response || "N/A" },
  ],

  basicFilters: [
    { key: "NAME", label: "Page Name", type: "text" },
    { key: "COUNTRY", label: "Country", type: "text" },
    { key: "EMAIL", label: "Email", type: "text" },
    { key: "PHONE", label: "Phone", type: "text" },
    { key: "WEBSITE", label: "Website", type: "text" },
    { key: "FOLLOWERS", label: "Followers", type: "number" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_PHONE", label: "Has Phone", type: "bool" },
    { key: "HAS_WEBSITE", label: "Has Website", type: "bool" },
    { key: "IS_FACEBOOK_PAGE", label: "Is Facebook Page", type: "bool" },
  ],

  sections: [
    // Profile Header
 

    { 
      type: "profile_header", 
      label: "Profile", 
      getValue: (result) => {
        const name = result.raw_data?.name;
        if (!name) return null;
        return {
          username: name,
          url: result.url || result.raw_data?.url,
          full_name: name,
          profile_pic_url: result.raw_data?.avatar_url,
          subtitle: result.raw_data?.category || null
        };
      }
    },
    
    // Status Text
    { 
      type: "text", 
      key: "status_text", 
      label: 'Status / Bio', 
      getValue: (result) => result.raw_data?.status_text, 
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto" 
      } 
    },
    
    // AI Raw Response
    { 
      type: "text", 
      key: "raw_response", 
      label: 'AI Analysis', 
      getValue: (result) => result.raw_data?.raw_response,
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto",
        background: "#f0fdf4"
      } 
    },
    
    // Stats
    { 
      type: "stats", 
      label: "Page Stats", 
      items: [
        { 
          key: "followers", 
          label: "Followers", 
          getValue: (result) => {
            const followers = result.raw_data?.followers;
            return followers ? followers.toLocaleString() : "0";
          }, 
          icon: "👥" 
        },
        { 
          key: "following", 
          label: "Following", 
          getValue: (result) => {
            const following = result.raw_data?.following;
            return following ? following.toLocaleString() : "0";
          }, 
          icon: "👣" 
        },
      ]
    },
    
    // Contact Info
    { 
      type: "meta", 
      label: "Contact Information", 
      items: [
        { 
          key: "email", 
          label: "Email", 
          getValue: (result) => result.raw_data?.email, 
          icon: "✉️" 
        },
        { 
          key: "phone", 
          label: "Phone", 
          getValue: (result) => result.raw_data?.phone, 
          icon: "📞" 
        },
        { 
          key: "website", 
          label: "Website", 
          getValue: (result) => result.raw_data?.website, 
          isLink: true, 
          icon: "🌐" 
        },
        { 
          key: "address", 
          label: "Address", 
          getValue: (result) => result.raw_data?.address, 
          icon: "📍" 
        },
      ]
    },
    
    // Country & Business Info
    { 
      type: "meta", 
      label: "Details", 
      items: [
        { 
          key: "country", 
          label: "Country", 
          getValue: (result) => result.raw_data?.country, 
          icon: "🌍" 
        },
        { 
          key: "business_hours", 
          label: "Business Hours", 
          getValue: (result) => result.raw_data?.business_hours, 
          icon: "🕒" 
        },
        { 
          key: "is_facebook_page", 
          label: "Facebook Page", 
          getValue: (result) => result.raw_data?.is_facebook_page ? "Yes ✅" : "No ❌", 
          icon: "📄" 
        },
      ]
    },
    
    // Source & Meta
    { 
      type: "meta", 
      label: "Post Info", 
      items: [
        { 
          key: "url", 
          label: "Facebook URL", 
          getValue: (result) => result.url, 
          isLink: true, 
          icon: "🔗" 
        },
        { 
          key: "created_at", 
          label: "Scraped", 
          getValue: (result) => formatDate(result.created_at), 
          icon: "📅" 
        },
      ]
    }
  ]
},
  instagram_adb: {
  title: 'Instagram ADB',
  aiVariables: [
    { key: "COUNTRY", label: "Country", getValue: (result) => result.raw_data?.country || "N/A" },
    { key: "USERNAME", label: "Username", getValue: (result) => result.raw_data?.username || "N/A" },
    { key: "FULL_NAME", label: "Full Name", getValue: (result) => result.raw_data?.full_name || "N/A" },
    { key: "BIO", label: "Bio", getValue: (result) => result.raw_data?.bio || "N/A" },
    { key: "EMAIL", label: "Email", getValue: (result) => result.raw_data?.email || "N/A" },
    { key: "FOLLOWERS", label: "Followers", getValue: (result) => String(result.raw_data?.followers || "0") },
    { key: "FOLLOWING", label: "Following", getValue: (result) => String(result.raw_data?.following || "0") },
    { key: "MEDIACOUNT", label: "Posts", getValue: (result) => String(result.raw_data?.mediacount || "0") },
    { key: "LINKS", label: "Links", getValue: (result) => {
      const links = result.raw_data?.links;
      return Array.isArray(links) ? links.join(', ') : "N/A";
    }},
    { key: "SCREENSHOT", label: "Screenshot", getValue: (result) => result.raw_data?.screenshot_url || "N/A" },
    // ─── WEBSITE INFO (полная копия dns_resolving.aiVariables) ──────
    { key: "WEBSITE_URL", label: "Website URL",
      getValue: (result) => getWebsiteInfo(result)[0]?.url || null },
    { key: "WEBSITE_FINAL_URL", label: "Website Final URL",
      getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.final_url || null },
    { key: "WEBSITE_TITLE", label: "Website Title",
      getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.title || null },
    { key: "WEBSITE_DESCRIPTION", label: "Website Description",
      getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.description || null },
    { key: "WEBSITE_STATUS", label: "Website Status",
      getValue: (result) => getWebsiteInfo(result)[0]?.status || null },
    { key: "WEBSITE_MATCHED_RULE", label: "Website Matched Rule",
      getValue: (result) => getWebsiteInfo(result)[0]?.raw_data?.dns?.matched_rule || null },
    { key: "WEBSITE_EMAILS", label: "Website Emails",
      getValue: (result) => {
        const emails = collectWebsiteEmails(getWebsiteInfo(result));
        return emails.length ? emails.join(", ") : null;
      } },
    { key: "HAS_WEBSITE_EMAIL", label: "Has Website Email",
      getValue: (result) => String(collectWebsiteEmails(getWebsiteInfo(result)).length > 0) },
    { key: "WEBSITE_HAS_SPA", label: "Website Has SPA",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "has_spa")) },
    { key: "WEBSITE_HAS_CONTACT_FORM", label: "Website Has Contact Form",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "has_contact_form")) },
    { key: "WEBSITE_EMAIL_PROTECTED", label: "Website Email Protected",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "email_protected")) },
    { key: "WEBSITE_CAPTCHA_DETECTED", label: "Website Captcha Detected",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "captcha_detected")) },
    { key: "WEBSITE_CALENDLY_FOUND", label: "Website Calendly Found",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "calendly_found")) },
    { key: "WEBSITE_GOOGLE_FORMS_FOUND", label: "Website Google Forms",
      getValue: (result) => String(anyWebsiteFlag(getWebsiteInfo(result), "google_forms_found")) },
    { key: "WEBSITE_SOCIAL_COUNT", label: "Website Social Links",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        const total = sites.reduce((acc, s) => {
          const sm = s?.raw_data?.social_media;
          return acc + (Array.isArray(sm) ? sm.length : 0);
        }, 0);
        return String(total);
      } },
    { key: "HAS_WEBSITE_FACEBOOK", label: "Has Website Facebook",
      getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "facebook")) },
    { key: "HAS_WEBSITE_INSTAGRAM", label: "Has Website Instagram",
      getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "instagram")) },
    { key: "HAS_WEBSITE_TWITTER", label: "Has Website Twitter",
      getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "twitter")) },
    { key: "HAS_WEBSITE_LINKEDIN", label: "Has Website LinkedIn",
      getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "linkedin")) },
    { key: "HAS_WEBSITE_YOUTUBE", label: "Has Website YouTube",
      getValue: (result) => String(websiteHasPlatform(getWebsiteInfo(result), "youtube")) },
    { key: "WEBSITE_TEXT_33", label: "Website Text (33%)",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        if (!sites.length) return null;
        const txt = sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || "";
        if (!txt) return null;
        return txt.slice(0, Math.floor(txt.length * 0.33));
      } },
    { key: "WEBSITE_TEXT_66", label: "Website Text (66%)",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        if (!sites.length) return null;
        const txt = sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || "";
        if (!txt) return null;
        return txt.slice(0, Math.floor(txt.length * 0.66));
      } },
    { key: "WEBSITE_TEXT", label: "Website Full Text",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        if (!sites.length) return null;
        return sites[0]?.raw_data?.main_page_text || sites[0]?.raw_data?.text || null;
      } },
    // ─── EMAILS FOUND / CONTACT FORMS (с указанием страниц) ────────
    { key: "WEBSITE_EMAILS_FOUND", label: "Website Emails (with pages)",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        const out = [];
        sites.forEach((s) => {
          const arr = s?.raw_data?.emails_found;
          if (Array.isArray(arr)) {
            arr.forEach((e) => {
              if (e?.email) out.push(`${e.email} @ ${e.page_url || "?"}${e.protected ? " [protected]" : ""}`);
            });
          }
        });
        return out.length ? out.join("\n") : null;
      } },
    { key: "WEBSITE_CONTACT_FORMS", label: "Website Contact Forms (with pages)",
      getValue: (result) => {
        const sites = getWebsiteInfo(result);
        const out = [];
        sites.forEach((s) => {
          const arr = s?.raw_data?.contact_forms_found;
          if (Array.isArray(arr)) {
            arr.forEach((f) => {
              if (f?.page_url) {
                out.push(`${f.page_url}${f.via_heuristic ? " [heuristic]" : ""}${f.captcha ? ` [captcha: ${f.captcha}]` : ""}${f.iframe_url ? ` [iframe: ${f.iframe_url}]` : ""}`);
              }
            });
          }
        });
        return out.length ? out.join("\n") : null;
      } },
  ],

  basicFilters: [
    { key: "COUNTRY", label: "Country", type: "text" },
    { key: "USERNAME", label: "Username", type: "text" },
    { key: "FULL_NAME", label: "Full Name", type: "text" },
    { key: "BIO", label: "Bio", type: "text" },
    { key: "EMAIL", label: "Email", type: "text" },
    { key: "FOLLOWERS", label: "Followers", type: "number" },
    { key: "FOLLOWING", label: "Following", type: "number" },
    { key: "MEDIACOUNT", label: "Posts", type: "number" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_LINKS", label: "Has Links", type: "bool" },
    { key: "HAS_SCREENSHOT", label: "Has Screenshot", type: "bool" },
    {
      key: "LAST_POST_DATE",
      label: "Last post date",
      type: "date"
    },
    // ─── WEBSITE INFO (полная копия dns_resolving.basicFilters) ─────
    { key: "WEBSITE_URL", label: "Website URL", type: "text" },
    { key: "WEBSITE_TITLE", label: "Website Title", type: "text" },
    { key: "WEBSITE_DESCRIPTION", label: "Website Description", type: "text" },
    { key: "WEBSITE_TEXT", label: "Website Text", type: "text" },
    { key: "WEBSITE_MATCHED_RULE", label: "Website Matched Rule", type: "text" },
    { key: "WEBSITE_EMAIL", label: "Website Email", type: "text" },
    { key: "HAS_WEBSITE_REDIRECT", label: "Website Has Redirect", type: "bool" },
    { key: "HAS_WEBSITE_EMAIL", label: "Website Has Email", type: "bool" },
    { key: "WEBSITE_HAS_SPA", label: "Website Has SPA", type: "bool" },
    { key: "WEBSITE_HAS_CONTACT_FORM", label: "Website Has Contact Form", type: "bool" },
    { key: "WEBSITE_EMAIL_PROTECTED", label: "Website Email Protected", type: "bool" },
    { key: "WEBSITE_CAPTCHA_DETECTED", label: "Website Captcha Detected", type: "bool" },
    { key: "WEBSITE_CALENDLY_FOUND", label: "Website Calendly Found", type: "bool" },
    { key: "WEBSITE_GOOGLE_FORMS_FOUND", label: "Website Google Forms Found", type: "bool" },
    { key: "HAS_WEBSITE_FACEBOOK", label: "Website Has Facebook", type: "bool" },
    { key: "HAS_WEBSITE_INSTAGRAM", label: "Website Has Instagram", type: "bool" },
    { key: "HAS_WEBSITE_TWITTER", label: "Website Has Twitter", type: "bool" },
    { key: "HAS_WEBSITE_LINKEDIN", label: "Website Has LinkedIn", type: "bool" },
    { key: "HAS_WEBSITE_YOUTUBE", label: "Website Has YouTube", type: "bool" },
  ],

  sections: [
    // Profile Header
    {
      type: "profile_header",
      label: "Profile",
      getValue: (result) => {
        const username = result.raw_data?.username;
        if (!username) return null;
        return {
          username: `${username}`,
          url: `https://instagram.com/${username}`,
          full_name: result.raw_data?.full_name,
          profile_pic_url: null
        };
      }
    },

    // Bio
    {
      type: "text",
      key: "bio",
      label: 'Bio',
      getValue: (result) => result.raw_data?.bio,
      style: {
        fontSize: 14,
        lineHeight: 1.7,
        whiteSpace: "pre-wrap",
        maxHeight: 300,
        overflowY: "auto"
      }
    },

    // Email
    {
      type: "text",
      key: "email",
      label: 'Email',
      getValue: (result) => {
        const email = result.raw_data?.email;
        return email || null;
      },
      style: {
        fontSize: 14,
        lineHeight: 1.7
      }
    },

    // Links - ВСЕ ССЫЛКИ В СТОЛБИК (кликабельные)
    {
      type: "custom",
      key: "links",
      label: 'Links',
      render: (result) => {
        const links = result.raw_data?.links;

        if (!Array.isArray(links) || links.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No links available
            </div>
          );
        }

        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {links.map((link, index) => {
              const href = link.startsWith('http') ? link : `https://${link}`;
              return (
                <div
                  key={index}
                  style={{
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#1890ff',
                      textDecoration: 'none',
                      wordBreak: 'break-all',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.textDecoration = 'underline';
                      e.target.style.color = '#40a9ff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.textDecoration = 'none';
                      e.target.style.color = '#1890ff';
                    }}
                  >
                    🔗 {link}
                  </a>
                </div>
              );
            })}
          </div>
        );
      }
    },

    {
      type: "custom",
      key: "latest_posts",
      label: 'Latest posts',
      render: (result) => {
        const latest_posts = result.raw_data?.latest_posts;

        if (!Array.isArray(latest_posts) || latest_posts.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No posts available
            </div>
          );
        }

        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {latest_posts.map((post, index) => {
              return (
                <div
                  key={index}
                  style={{
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  {post}
                </div>
              );
            })}
          </div>
        );
      }
    },

    // Stats
    {
      type: "stats",
      label: "Page Stats",
      items: [
        {
          key: "followers",
          label: "Followers",
          getValue: (result) => result.raw_data?.followers?.toLocaleString() || "0",
          icon: "👥"
        },
        {
          key: "following",
          label: "Following",
          getValue: (result) => result.raw_data?.following?.toLocaleString() || "0",
          icon: "👣"
        },
        {
          key: "posts",
          label: "Posts",
          getValue: (result) => result.raw_data?.mediacount?.toLocaleString() || "0",
          icon: "📝"
        },
      ]
    },

    // Country
    {
      type: "meta",
      label: "Location",
      items: [
        {
          key: "country",
          label: "Country",
          getValue: (result) => result.raw_data?.country,
          icon: "🌍"
        },
      ]
    },

    // ─── Website Info: полная копия dns_resolving.sections ──────────
    {
      type: "custom",
      key: "website_info",
      label: "Websites",
      hideWhenEmpty: true,
      render: (result) => {
        const sites = getWebsiteInfo(result);
        if (!sites.length) return null;

        return (
          <div style={{ fontSize: 13, lineHeight: 1.6 }}>
            {sites.map((site, idx) => {
              const r = site.raw_data || {};
              const emails = Array.isArray(r.emails) ? r.emails : [];
              const socials = Array.isArray(r.social_media) ? r.social_media : [];
              const captchaTypes = Array.isArray(r.captcha_types) ? r.captcha_types : [];
              const spaReasons = Array.isArray(r.spa_reasons) ? r.spa_reasons : [];
              const fetchErrors = Array.isArray(r.fetch_errors) ? r.fetch_errors : [];
              const checkedPages = Array.isArray(r.checked_pages) ? r.checked_pages : [];
              const emailsFound = Array.isArray(r.emails_found) ? r.emails_found : [];
              const contactForms = Array.isArray(r.contact_forms_found) ? r.contact_forms_found : [];

              const domain = r.dns?.domain
                || (site.url || "").replace(/^https?:\/\//, "").split("/")[0];

              const hasPlatform = (p) => socials.some((s) => s.platform === p);

              const flags = [
                { label: "Has Email", value: emails.length > 0, icon: "✉️" },
                { label: "SPA", value: r.has_spa, icon: "⚡" },
                { label: "Contact Form", value: r.has_contact_form, icon: "📝" },
                { label: "Email Protected", value: r.email_protected, icon: "🔒" },
                { label: "Captcha Detected", value: r.captcha_detected, icon: "🤖" },
                { label: "Calendly Found", value: r.calendly_found, icon: "📅" },
                { label: "Google Forms", value: r.google_forms_found, icon: "📋" },
                { label: "Facebook", value: hasPlatform("facebook"), icon: "📘" },
                { label: "Instagram", value: hasPlatform("instagram"), icon: "📷" },
                { label: "Twitter", value: hasPlatform("twitter"), icon: "🐦" },
                { label: "LinkedIn", value: hasPlatform("linkedin"), icon: "💼" },
                { label: "YouTube", value: hasPlatform("youtube"), icon: "▶️" },
              ].filter((f) => f.value !== undefined && f.value !== null);

              const textKey = r.main_page_text_key;
              const fallbackText = r.main_page_text || r.text;

              // группировка social по платформе
              const groupedSocials = {};
              socials.forEach((s) => {
                if (!groupedSocials[s.platform]) groupedSocials[s.platform] = new Set();
                groupedSocials[s.platform].add(s.url);
              });
              const socialIcons = {
                facebook: "📘",
                instagram: "📷",
                twitter: "🐦",
                linkedin: "💼",
                youtube: "▶️",
              };

              return (
                <div
                  key={idx}
                  style={{
                    marginBottom: 18,
                    padding: "12px 14px",
                    border: "1px solid #d1d5db",
                    borderRadius: 10,
                    background: "#ffffff",
                  }}
                >
                  {/* ─── Site header (domain + status) ──────────────── */}
                  <div
                    style={{
                      marginBottom: 10,
                      paddingBottom: 8,
                      borderBottom: "1px solid #e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 6,
                    }}
                  >
                    <a
                      href={r.final_url || site.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1890ff",
                        textDecoration: "none",
                        fontWeight: 700,
                        fontSize: 15,
                        wordBreak: "break-all",
                      }}
                    >
                      🌐 {domain || site.url}
                    </a>
                    <span
                      style={{
                        padding: "2px 10px",
                        borderRadius: 10,
                        fontSize: 11,
                        background: site.status === "success" ? "#dcfce7" : "#fef3c7",
                        color: site.status === "success" ? "#166534" : "#92400e",
                      }}
                    >
                      {site.status || "unknown"}
                    </span>
                  </div>

                  {/* ─── Profile header (title + final url) ────────── */}
                  <div style={{ marginBottom: 10 }}>
                    {r.title && (
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                        {r.title}
                      </div>
                    )}
                    {r.final_url && (
                      <div style={{ marginTop: 4 }}>
                        <a
                          href={r.final_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#1890ff",
                            textDecoration: "none",
                            fontSize: 12,
                            wordBreak: "break-all",
                          }}
                        >
                          🔗 {r.final_url}
                        </a>
                      </div>
                    )}
                  </div>

                  {/* ─── Title section ────────────────────────────── */}
                  {r.title && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Title
                      </div>
                      <div style={{
                        fontSize: 13,
                        lineHeight: 1.7,
                        whiteSpace: "pre-wrap",
                        maxHeight: 300,
                        overflowY: "auto",
                        background: "#f9fafb",
                        padding: "8px 10px",
                        borderRadius: 6,
                      }}>
                        {r.title}
                      </div>
                    </div>
                  )}

                  {/* ─── Description section ──────────────────────── */}
                  {r.description && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Description
                      </div>
                      <div style={{
                        fontSize: 13,
                        lineHeight: 1.7,
                        whiteSpace: "pre-wrap",
                        maxHeight: 300,
                        overflowY: "auto",
                        background: "#f9fafb",
                        padding: "8px 10px",
                        borderRadius: 6,
                      }}>
                        {r.description}
                      </div>
                    </div>
                  )}

                  {/* ─── Website Text (S3 link or fallback) ───────── */}
                  {(textKey || fallbackText) && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Website Text
                      </div>
                      {textKey ? (
                        <a
                          href={`${S3_BASE_URL}/${textKey}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-block",
                            padding: "6px 12px",
                            border: "1.5px solid #1890ff",
                            borderRadius: 8,
                            color: "#1890ff",
                            textDecoration: "none",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          📄 Open Website Text
                        </a>
                      ) : (
                        <div style={{
                          fontSize: 13,
                          lineHeight: 1.7,
                          whiteSpace: "pre-wrap",
                          maxHeight: 400,
                          overflowY: "auto",
                          background: "#fafafa",
                          padding: "8px 12px",
                          borderRadius: 8,
                        }}>
                          {fallbackText}
                        </div>
                      )}
                    </div>
                  )}

                  {/* ─── Matched Rule ────────────────────────────── */}
                  {r.dns?.matched_rule && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Matched Rule
                      </div>
                      <div style={{
                        fontSize: 13,
                        lineHeight: 1.7,
                        whiteSpace: "pre-wrap",
                        background: "#f0fdf4",
                        padding: "8px 12px",
                        borderRadius: 8,
                        color: "#065f46",
                      }}>
                        {r.dns.matched_rule}
                      </div>
                    </div>
                  )}

                  {/* ─── Emails (with pages) ──────────────────────── */}
                  {emails.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Emails ({emails.length})
                      </div>
                      <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                        {emails.map((email, i) => {
                          const found = emailsFound.filter((e) => e.email === email);
                          return (
                            <div key={i} style={{ marginBottom: 6 }}>
                              <a
                                href={`mailto:${email}`}
                                style={{ color: "#1890ff", textDecoration: "none" }}
                              >
                                ✉️ {email}
                              </a>
                              {found.length > 0 && (
                                <div style={{ marginLeft: 16, fontSize: 11, color: "#6b7280" }}>
                                  {found.map((f, j) => (
                                    <div key={j}>
                                      found on:{" "}
                                      <a
                                        href={f.page_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "#1890ff",
                                          textDecoration: "none",
                                          wordBreak: "break-all",
                                        }}
                                      >
                                        {f.page_url}
                                      </a>
                                      {f.protected && (
                                        <span style={{ marginLeft: 6, color: "#92400e" }}>
                                          🔒 protected
                                        </span>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* ─── Contact Forms (with pages) ──────────────── */}
                  {contactForms.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Contact Forms ({contactForms.length})
                      </div>
                      <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                        {contactForms.map((f, i) => (
                          <div key={i} style={{ marginBottom: 4 }}>
                            📝{" "}
                            <a
                              href={f.page_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1890ff",
                                textDecoration: "none",
                                wordBreak: "break-all",
                              }}
                            >
                              {f.page_url}
                            </a>
                            {f.via_heuristic && (
                              <span style={{ marginLeft: 6, fontSize: 11, color: "#6b7280" }}>
                                (heuristic)
                              </span>
                            )}
                            {f.captcha && (
                              <span style={{ marginLeft: 6, fontSize: 11, color: "#92400e" }}>
                                🤖 {f.captcha}
                              </span>
                            )}
                            {f.iframe_url && (
                              <div style={{ marginLeft: 16, fontSize: 11 }}>
                                iframe:{" "}
                                <a
                                  href={f.iframe_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#1890ff",
                                    textDecoration: "none",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {f.iframe_url}
                                </a>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ─── Social Media (grouped) ───────────────────── */}
                  {socials.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Social Media
                      </div>
                      <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                        {Object.entries(groupedSocials).map(([platform, urls]) => (
                          <div key={platform} style={{ marginBottom: 8 }}>
                            <div style={{ fontWeight: 600, marginBottom: 3, color: "#4b5563", fontSize: 12 }}>
                              {socialIcons[platform] || "🔗"} {platform} ({urls.size})
                            </div>
                            {[...urls].map((url, i) => (
                              <div key={i} style={{ marginLeft: 16, marginBottom: 2 }}>
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#1890ff",
                                    textDecoration: "none",
                                    wordBreak: "break-all",
                                    fontSize: 12,
                                  }}
                                >
                                  {url}
                                </a>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ─── Detection Flags ─────────────────────────── */}
                  {flags.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Detection Flags
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {flags.map((f) => (
                          <span
                            key={f.label}
                            style={{
                              padding: "3px 9px",
                              borderRadius: 12,
                              fontSize: 11,
                              background: f.value ? "#dcfce7" : "#f3f4f6",
                              color: f.value ? "#166534" : "#6b7280",
                              border: `1px solid ${f.value ? "#86efac" : "#e5e7eb"}`,
                            }}
                          >
                            {f.icon} {f.label}: {f.value ? "Yes" : "No"}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ─── Captcha Types ───────────────────────────── */}
                  {captchaTypes.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Captcha Types
                      </div>
                      <div style={{ fontSize: 13, lineHeight: 1.7, color: "#4b5563" }}>
                        {captchaTypes.join(", ")}
                      </div>
                    </div>
                  )}

                  {/* ─── SPA Reasons ─────────────────────────────── */}
                  {spaReasons.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        SPA Reasons
                      </div>
                      <div style={{ fontSize: 13, lineHeight: 1.7, color: "#4b5563" }}>
                        {spaReasons.join(", ")}
                      </div>
                    </div>
                  )}

                  {/* ─── Fetch Errors ────────────────────────────── */}
                  {fetchErrors.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Fetch Errors
                      </div>
                      <div style={{
                        fontSize: 12,
                        lineHeight: 1.6,
                        color: "#b91c1c",
                        whiteSpace: "pre-wrap",
                        background: "#fef2f2",
                        padding: "6px 10px",
                        borderRadius: 6,
                      }}>
                        {fetchErrors.map((e, i) => (
                          <div key={i}>{typeof e === "string" ? e : JSON.stringify(e)}</div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ─── Website Text (full, fallback if no S3) ──── */}
                  {!textKey && fallbackText && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Website Text (full)
                      </div>
                      <div style={{
                        fontSize: 12,
                        lineHeight: 1.7,
                        whiteSpace: "pre-wrap",
                        maxHeight: 400,
                        overflowY: "auto",
                        background: "#fafafa",
                        padding: "8px 12px",
                        borderRadius: 8,
                      }}>
                        {fallbackText}
                      </div>
                    </div>
                  )}

                  {/* ─── Checked Pages ───────────────────────────── */}
                  {checkedPages.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Checked Pages ({checkedPages.length})
                      </div>
                      <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                        {checkedPages.map((p, i) => (
                          <div key={i} style={{ marginBottom: 2 }}>
                            <a
                              href={p}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                            >
                              🔍 {p}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ─── Details (meta) ──────────────────────────── */}
                  <div style={{ marginBottom: 6 }}>
                    <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                      Details
                    </div>
                    <div style={{ fontSize: 12, lineHeight: 1.7, color: "#4b5563" }}>
                      {r.worker && (
                        <div>⚙️ Worker: {r.worker}</div>
                      )}
                      {r.root_url && (
                        <div>
                          🔗 Root URL:{" "}
                          <a
                            href={r.root_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                          >
                            {r.root_url}
                          </a>
                        </div>
                      )}
                      {r.final_url && (
                        <div>
                          🔗 Final URL:{" "}
                          <a
                            href={r.final_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                          >
                            {r.final_url}
                          </a>
                        </div>
                      )}
                      {r.timestamp && (
                        <div>🕒 Scraped At: {formatDate(r.timestamp)}</div>
                      )}
                      {site.url && (
                        <div>
                          🌐 URL:{" "}
                          <a
                            href={site.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                          >
                            {site.url}
                          </a>
                        </div>
                      )}
                      {site.completed_at && (
                        <div>📅 Completed: {formatDate(site.completed_at)}</div>
                      )}
                    </div>
                  </div>

                  {/* ─── Source (meta) ───────────────────────────── */}
                  {(site.source || r.source) && (
                    <div>
                      <div style={{ fontWeight: 600, color: "#374151", fontSize: 12, marginBottom: 4 }}>
                        Source
                      </div>
                      <div style={{ fontSize: 12, lineHeight: 1.7, color: "#4b5563" }}>
                        {(site.source?.scraped_url || r.source?.scraped_url) && (
                          <div>
                            🔍 Scraped URL:{" "}
                            <a
                              href={site.source?.scraped_url || r.source?.scraped_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#1890ff", textDecoration: "none", wordBreak: "break-all" }}
                            >
                              {site.source?.scraped_url || r.source?.scraped_url}
                            </a>
                          </div>
                        )}
                        {(site.source?.keyword || r.source?.keyword) && (
                          <div>🔑 Keyword: {site.source?.keyword || r.source?.keyword}</div>
                        )}
                        {(site.source?.search_position || r.source?.search_position) && (
                          <div>📍 Position: {site.source?.search_position || r.source?.search_position}</div>
                        )}
                        {(site.source?.search_page || r.source?.search_page) && (
                          <div>📄 Search Page: {site.source?.search_page || r.source?.search_page}</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },

    // Screenshot
    {
      type: "image",
      key: "screenshot_url",
      label: "Screenshot",
      getValue: (result) => "https://flautreach.com/media/" + result.raw_data?.screenshot_url,
      style: {
        maxHeight: 500,
        objectFit: "contain",
        borderRadius: 12,
        background: "#f5f5f5"
      }
    },

    // Meta
    {
      type: "meta",
      label: "Details",
      items: [
        {
          key: "url",
          label: "Instagram URL",
          getValue: (result) => result.url,
          isLink: true,
          icon: "🔗"
        },
        {
          key: "created_at",
          label: "Scraped",
          getValue: (result) => formatDate(result.created_at),
          icon: "📅"
        },
      ]
    }
  ]
},

dns_resolving: {
  title: 'Website / DNS Resolving',

  aiVariables: [
    { key: "URL", label: "URL",
      getValue: (result) => result.url || null },
    { key: "FINAL_URL", label: "Final URL",
      getValue: (result) => result.raw_data?.final_url || null },
    { key: "TITLE", label: "Title",
      getValue: (result) => result.raw_data?.title || null },
    { key: "DESCRIPTION", label: "Description",
      getValue: (result) => result.raw_data?.description || null },
    { key: "STATUS", label: "Status",
      getValue: (result) => result.status || null },
    { key: "MATCHED_RULE", label: "Matched Rule",
      getValue: (result) => result.raw_data?.dns?.matched_rule || null },

    { key: "EMAILS", label: "Emails",
      getValue: (result) => {
        const emails = result.raw_data?.emails;
        return Array.isArray(emails) && emails.length ? emails.join(", ") : null;
      } },
    { key: "HAS_EMAIL", label: "Has Email",
      getValue: (result) => {
        const emails = result.raw_data?.emails;
        return Array.isArray(emails) ? String(emails.length > 0) : null;
      } },
    { key: "HAS_SPA", label: "Has SPA",
      getValue: (result) => result.raw_data?.has_spa != null ? String(result.raw_data.has_spa) : null },
    { key: "HAS_CONTACT_FORM", label: "Has Contact Form",
      getValue: (result) => result.raw_data?.has_contact_form != null ? String(result.raw_data.has_contact_form) : null },
    { key: "EMAIL_PROTECTED", label: "Email Protected",
      getValue: (result) => result.raw_data?.email_protected != null ? String(result.raw_data.email_protected) : null },
    { key: "CAPTCHA_DETECTED", label: "Captcha Detected",
      getValue: (result) => result.raw_data?.captcha_detected != null ? String(result.raw_data.captcha_detected) : null },
    { key: "CALENDLY_FOUND", label: "Calendly Found",
      getValue: (result) => result.raw_data?.calendly_found != null ? String(result.raw_data.calendly_found) : null },
    { key: "GOOGLE_FORMS_FOUND", label: "Google Forms",
      getValue: (result) => result.raw_data?.google_forms_found != null ? String(result.raw_data.google_forms_found) : null },
    { key: "SOCIAL_COUNT", label: "Social Links",
      getValue: (result) => result.raw_data?.social_media ? String(result.raw_data.social_media.length) : null },

    // === per-platform flags ===
    { key: "HAS_FACEBOOK", label: "Has Facebook",
      getValue: (result) => result.raw_data?.social_media
        ? String(result.raw_data.social_media.some((s) => s.platform === "facebook"))
        : null },
    { key: "HAS_INSTAGRAM", label: "Has Instagram",
      getValue: (result) => result.raw_data?.social_media
        ? String(result.raw_data.social_media.some((s) => s.platform === "instagram"))
        : null },
    { key: "HAS_TWITTER", label: "Has Twitter",
      getValue: (result) => result.raw_data?.social_media
        ? String(result.raw_data.social_media.some((s) => s.platform === "twitter"))
        : null },
    { key: "HAS_LINKEDIN", label: "Has LinkedIn",
      getValue: (result) => result.raw_data?.social_media
        ? String(result.raw_data.social_media.some((s) => s.platform === "linkedin"))
        : null },
    { key: "HAS_YOUTUBE", label: "Has YouTube",
      getValue: (result) => result.raw_data?.social_media
        ? String(result.raw_data.social_media.some((s) => s.platform === "youtube"))
        : null },

    // === TEXT: 33% / 66% / full ===
    { key: "TEXT_33", label: "Text (33%)",
      getValue: (result) => {
        const txt = result.raw_data?.main_page_text || result.raw_data?.text || "";
        if (!txt) return null;
        return txt.slice(0, Math.floor(txt.length * 0.33));
      } },
    { key: "TEXT_66", label: "Text (66%)",
      getValue: (result) => {
        const txt = result.raw_data?.main_page_text || result.raw_data?.text || "";
        if (!txt) return null;
        return txt.slice(0, Math.floor(txt.length * 0.66));
      } },
    { key: "TEXT", label: "Full Text",
      getValue: (result) => result.raw_data?.main_page_text || result.raw_data?.text || null },

    // === EMAILS FOUND / CONTACT FORMS (с указанием страниц) ===
    { key: "EMAILS_FOUND", label: "Emails Found (with pages)",
      getValue: (result) => {
        const arr = result.raw_data?.emails_found;
        if (!Array.isArray(arr) || !arr.length) return null;
        return arr.map((e) => `${e.email} @ ${e.page_url}${e.protected ? " [protected]" : ""}`).join("\n");
      } },
    { key: "CONTACT_FORMS", label: "Contact Forms (with pages)",
      getValue: (result) => {
        const arr = result.raw_data?.contact_forms_found;
        if (!Array.isArray(arr) || !arr.length) return null;
        return arr.map((f) => `${f.page_url}${f.via_heuristic ? " [heuristic]" : ""}${f.captcha ? ` [captcha: ${f.captcha}]` : ""}${f.iframe_url ? ` [iframe: ${f.iframe_url}]` : ""}`).join("\n");
      } },
  ],

  basicFilters: [
    { key: "URL", label: "URL", type: "text" },
    { key: "TITLE", label: "Title", type: "text" },
    { key: "DESCRIPTION", label: "Description", type: "text" },
    { key: "TEXT", label: "Text", type: "text" },

    { key: "MATCHED_RULE", label: "Matched Rule", type: "text" },

    { key: "EMAIL", label: "Email", type: "text" },
    { key: "HAS_REDIRECT", label: "Has Redirect", type: "bool" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_SPA", label: "Has SPA", type: "bool" },
    { key: "HAS_CONTACT_FORM", label: "Has Contact Form", type: "bool" },
    { key: "EMAIL_PROTECTED", label: "Email Protected", type: "bool" },
    { key: "CAPTCHA_DETECTED", label: "Captcha Detected", type: "bool" },
    { key: "CALENDLY_FOUND", label: "Calendly Found", type: "bool" },
    { key: "GOOGLE_FORMS_FOUND", label: "Google Forms Found", type: "bool" },
    { key: "HAS_FACEBOOK", label: "Has Facebook", type: "bool" },
    { key: "HAS_INSTAGRAM", label: "Has Instagram", type: "bool" },
    { key: "HAS_TWITTER", label: "Has Twitter", type: "bool" },
    { key: "HAS_LINKEDIN", label: "Has LinkedIn", type: "bool" },
    { key: "HAS_YOUTUBE", label: "Has YouTube", type: "bool" },
  ],

  sections: [
    // Profile Header — домен + финальный URL + статус
    {
      type: "profile_header",
      label: "Website",
      hideWhenEmpty: true,
      getValue: (result) => {
        const domain = result.raw_data?.dns?.domain
          || (result.url || "").replace(/^https?:\/\//, "").split("/")[0];
        if (!domain) return null;
        return {
          username: domain,
          url: result.raw_data?.final_url || result.url,
          full_name: result.raw_data?.title || domain,
          profile_pic_url: null,
          subtitle: result.status || null,
        };
      },
    },

    // Title
    {
      type: "text",
      key: "title",
      label: "Title",
      hideWhenEmpty: true,
      getValue: (result) => result.raw_data?.title || null,
      style: {
        fontSize: 14,
        lineHeight: 1.7,
        whiteSpace: "pre-wrap",
        maxHeight: 300,
        overflowY: "auto",
      },
    },

    // Description
    {
      type: "text",
      key: "description",
      label: "Description",
      hideWhenEmpty: true,
      getValue: (result) => result.raw_data?.description || null,
      style: {
        fontSize: 14,
        lineHeight: 1.7,
        whiteSpace: "pre-wrap",
        maxHeight: 300,
        overflowY: "auto",
      },
    },

    // Website Text — ссылка на S3
    {
      type: "custom",
      key: "main_page_text",
      label: "Website Text",
      hideWhenEmpty: true,
      render: (result) => {
        const key = result.raw_data?.main_page_text_key;
        const fallbackText = result.raw_data?.main_page_text || result.raw_data?.text;
        if (key) {
          const url = `https://s3.twcstorage.ru/1069577a-d68b-409d-9398-fef1c9cce817/${key}`;
          return (
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#1890ff',
                  textDecoration: 'none',
                  wordBreak: 'break-all',
                  display: 'inline-block',
                  padding: '6px 10px',
                  border: '1.5px solid #1890ff',
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                📄 Open Website Text
              </a>
            </div>
          );
        }
        if (fallbackText) {
          return (
            <div style={{
              fontSize: 13, lineHeight: 1.7, whiteSpace: "pre-wrap",
              maxHeight: 400, overflowY: "auto",
              background: "#fafafa", padding: "8px 12px", borderRadius: 8,
            }}>
              {fallbackText}
            </div>
          );
        }
        return null;
      },
    },

    // Matched Rule
    {
      type: "text",
      key: "matched_rule",
      label: "Matched Rule",
      hideWhenEmpty: true,
      getValue: (result) => result.raw_data?.dns?.matched_rule || null,
      style: {
        fontSize: 14,
        lineHeight: 1.7,
        whiteSpace: "pre-wrap",
        background: "#f0fdf4",
        padding: "8px 12px",
        borderRadius: 8,
      },
    },

    // Emails (with pages)
    {
      type: "custom",
      key: "emails",
      label: "Emails",
      hideWhenEmpty: true,
      render: (result) => {
        const emails = result.raw_data?.emails;
        const emailsFound = Array.isArray(result.raw_data?.emails_found)
          ? result.raw_data.emails_found
          : [];
        if (!Array.isArray(emails) || emails.length === 0) return null;

        return (
          <div style={{ fontSize: 14, lineHeight: 1.7 }}>
            {emails.map((email, i) => {
              const found = emailsFound.filter((e) => e.email === email);
              return (
                <div key={i} style={{ marginBottom: 6 }}>
                  <a
                    href={`mailto:${email}`}
                    style={{ color: "#1890ff", textDecoration: "none" }}
                  >
                    ✉️ {email}
                  </a>
                  {found.length > 0 && (
                    <div style={{ marginLeft: 16, fontSize: 11, color: "#6b7280" }}>
                      {found.map((f, j) => (
                        <div key={j}>
                          found on:{" "}
                          <a
                            href={f.page_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#1890ff",
                              textDecoration: "none",
                              wordBreak: "break-all",
                            }}
                          >
                            {f.page_url}
                          </a>
                          {f.protected && (
                            <span style={{ marginLeft: 6, color: "#92400e" }}>
                              🔒 protected
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },

    // Contact Forms (with pages)
    {
      type: "custom",
      key: "contact_forms",
      label: "Contact Forms",
      hideWhenEmpty: true,
      render: (result) => {
        const forms = result.raw_data?.contact_forms_found;
        if (!Array.isArray(forms) || forms.length === 0) return null;
        return (
          <div style={{ fontSize: 14, lineHeight: 1.7 }}>
            {forms.map((f, i) => (
              <div key={i} style={{ marginBottom: 4 }}>
                📝{" "}
                <a
                  href={f.page_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1890ff",
                    textDecoration: "none",
                    wordBreak: "break-all",
                  }}
                >
                  {f.page_url}
                </a>
                {f.via_heuristic && (
                  <span style={{ marginLeft: 6, fontSize: 11, color: "#6b7280" }}>
                    (heuristic)
                  </span>
                )}
                {f.captcha && (
                  <span style={{ marginLeft: 6, fontSize: 11, color: "#92400e" }}>
                    🤖 {f.captcha}
                  </span>
                )}
                {f.iframe_url && (
                  <div style={{ marginLeft: 16, fontSize: 11 }}>
                    iframe:{" "}
                    <a
                      href={f.iframe_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1890ff",
                        textDecoration: "none",
                        wordBreak: "break-all",
                      }}
                    >
                      {f.iframe_url}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      },
    },

    // Social Media
    {
      type: "custom",
      key: "social_media",
      label: "Social Media",
      hideWhenEmpty: true,
      render: (result) => {
        const socials = result.raw_data?.social_media;
        if (!Array.isArray(socials) || socials.length === 0) return null;

        const grouped = {};
        socials.forEach((s) => {
          if (!grouped[s.platform]) grouped[s.platform] = new Set();
          grouped[s.platform].add(s.url);
        });

        const icons = {
          facebook: "📘",
          instagram: "📷",
          twitter: "🐦",
          linkedin: "💼",
          youtube: "▶️",
        };

        return (
          <div style={{ fontSize: 14, lineHeight: 1.7 }}>
            {Object.entries(grouped).map(([platform, urls]) => (
              <div key={platform} style={{ marginBottom: 10 }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>
                  {icons[platform] || "🔗"} {platform} ({urls.size})
                </div>
                {[...urls].map((url, i) => (
                  <div key={i} style={{ marginLeft: 16, marginBottom: 2 }}>
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#1890ff',
                        textDecoration: 'none',
                        wordBreak: 'break-all',
                      }}
                    >
                      {url}
                    </a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        );
      },
    },

    // Detection Flags
    {
      type: "custom",
      key: "flags",
      label: "Detection Flags",
      hideWhenEmpty: true,
      render: (result) => {
        const r = result.raw_data || {};
        const emails = Array.isArray(r.emails) ? r.emails : [];
        const socials = Array.isArray(r.social_media) ? r.social_media : [];
        const hasPlatform = (p) => socials.some((s) => s.platform === p);

        const flags = [
          { label: "Has Email", value: emails.length > 0, icon: "✉️" },
          { label: "SPA", value: r.has_spa, icon: "⚡" },
          { label: "Contact Form", value: r.has_contact_form, icon: "📝" },
          { label: "Email Protected", value: r.email_protected, icon: "🔒" },
          { label: "Captcha Detected", value: r.captcha_detected, icon: "🤖" },
          { label: "Calendly Found", value: r.calendly_found, icon: "📅" },
          { label: "Google Forms", value: r.google_forms_found, icon: "📋" },
          { label: "Facebook", value: hasPlatform("facebook"), icon: "📘" },
          { label: "Instagram", value: hasPlatform("instagram"), icon: "📷" },
          { label: "Twitter", value: hasPlatform("twitter"), icon: "🐦" },
          { label: "LinkedIn", value: hasPlatform("linkedin"), icon: "💼" },
          { label: "YouTube", value: hasPlatform("youtube"), icon: "▶️" },
        ].filter((f) => f.value !== undefined && f.value !== null);

        if (flags.length === 0) return null;

        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {flags.map((f) => (
              <span
                key={f.label}
                style={{
                  padding: '4px 10px',
                  borderRadius: 12,
                  fontSize: 12,
                  background: f.value ? '#dcfce7' : '#f3f4f6',
                  color: f.value ? '#166534' : '#6b7280',
                  border: `1px solid ${f.value ? '#86efac' : '#e5e7eb'}`,
                }}
              >
                {f.icon} {f.label}: {f.value ? "Yes" : "No"}
              </span>
            ))}
          </div>
        );
      },
    },

    // Captcha Types
    {
      type: "text",
      key: "captcha_types",
      label: "Captcha Types",
      hideWhenEmpty: true,
      getValue: (result) => {
        const types = result.raw_data?.captcha_types;
        return Array.isArray(types) && types.length ? types.join(", ") : null;
      },
      style: { fontSize: 14, lineHeight: 1.7 },
    },

    // SPA Reasons
    {
      type: "text",
      key: "spa_reasons",
      label: "SPA Reasons",
      hideWhenEmpty: true,
      getValue: (result) => {
        const reasons = result.raw_data?.spa_reasons;
        return Array.isArray(reasons) && reasons.length ? reasons.join(", ") : null;
      },
      style: { fontSize: 14, lineHeight: 1.7 },
    },

    // Fetch Errors
    {
      type: "text",
      key: "fetch_errors",
      label: "Fetch Errors",
      hideWhenEmpty: true,
      getValue: (result) => {
        const errs = result.raw_data?.fetch_errors;
        return Array.isArray(errs) && errs.length ? errs.join("\n") : null;
      },
      style: { fontSize: 13, lineHeight: 1.6, color: "#b91c1c", whiteSpace: "pre-wrap" },
    },

    // Website Text (полный)
    {
      type: "text",
      key: "main_page_text",
      label: "Website Text",
      hideWhenEmpty: true,
      getValue: (result) => result.raw_data?.main_page_text || result.raw_data?.text || null,
      style: {
        fontSize: 13,
        lineHeight: 1.7,
        whiteSpace: "pre-wrap",
        maxHeight: 400,
        overflowY: "auto",
        background: "#fafafa",
        padding: "8px 12px",
        borderRadius: 8,
      },
    },

    // Checked Pages
    {
      type: "custom",
      key: "checked_pages",
      label: "Checked Pages",
      hideWhenEmpty: true,
      render: (result) => {
        const pages = result.raw_data?.checked_pages;
        if (!Array.isArray(pages) || pages.length === 0) return null;
        return (
          <div style={{ fontSize: 13, lineHeight: 1.6 }}>
            {pages.map((p, i) => (
              <div key={i} style={{ marginBottom: 2 }}>
                <a href={p} target="_blank" rel="noopener noreferrer"
                   style={{ color: '#1890ff', textDecoration: 'none', wordBreak: 'break-all' }}>
                  🔍 {p}
                </a>
              </div>
            ))}
          </div>
        );
      },
    },

    // Details
    {
      type: "meta",
      label: "Details",
      hideWhenEmpty: true,
      items: [
        { key: "worker", label: "Worker", getValue: (r) => r.raw_data?.worker, icon: "⚙️" },
        { key: "root_url", label: "Root URL", getValue: (r) => r.raw_data?.root_url, isLink: true, icon: "🔗" },
        { key: "final_url", label: "Final URL", getValue: (r) => r.raw_data?.final_url, isLink: true, icon: "🔗" },
        { key: "timestamp", label: "Scraped At", getValue: (r) => r.raw_data?.timestamp ? formatDate(r.raw_data.timestamp) : null, icon: "🕒" },
        { key: "url", label: "URL", getValue: (r) => r.url, isLink: true, icon: "🌐" },
        { key: "created_at", label: "Added", getValue: (r) => formatDate(r.created_at), icon: "📅" },
      ],
    },

    // Source
    {
      type: "meta",
      label: "Source",
      hideWhenEmpty: true,
      items: [
        { key: "scraped_url", label: "Scraped URL", getValue: (r) => r.source?.scraped_url, isLink: true, icon: "🔍" },
        { key: "keyword", label: "Keyword", getValue: (r) => r.source?.keyword, icon: "🔑" },
        { key: "search_position", label: "Position", getValue: (r) => r.source?.search_position, icon: "📍" },
        { key: "search_page", label: "Search Page", getValue: (r) => r.source?.search_page, icon: "📄" },
      ],
    },
  ],
},

     dns_resolving_old: {
      title: 'Website / DNS Resolving',

      aiVariables: [
        
        { key: "URL", label: "URL",
          getValue: (result) => result.url || null },
        { key: "FINAL_URL", label: "Final URL",
          getValue: (result) => result.raw_data?.final_url || null },
        { key: "TITLE", label: "Title",
          getValue: (result) => result.raw_data?.title || null },
        { key: "DESCRIPTION", label: "Description",
          getValue: (result) => result.raw_data?.description || null },
        { key: "STATUS", label: "Status",
          getValue: (result) => result.status || null },
        { key: "MATCHED_RULE", label: "Matched Rule",
          getValue: (result) => result.raw_data?.dns?.matched_rule || null },
       
        { key: "EMAILS", label: "Emails",
          getValue: (result) => {
            const emails = result.raw_data?.emails;
            return Array.isArray(emails) && emails.length ? emails.join(", ") : null;
          } },
        { key: "HAS_EMAIL", label: "Has Email",
          getValue: (result) => {
            const emails = result.raw_data?.emails;
            return Array.isArray(emails) ? String(emails.length > 0) : null;
          } },
        { key: "HAS_SPA", label: "Has SPA",
          getValue: (result) => result.raw_data?.has_spa != null ? String(result.raw_data.has_spa) : null },
        { key: "HAS_CONTACT_FORM", label: "Has Contact Form",
          getValue: (result) => result.raw_data?.has_contact_form != null ? String(result.raw_data.has_contact_form) : null },
        { key: "EMAIL_PROTECTED", label: "Email Protected",
          getValue: (result) => result.raw_data?.email_protected != null ? String(result.raw_data.email_protected) : null },
        { key: "CAPTCHA_DETECTED", label: "Captcha Detected",
          getValue: (result) => result.raw_data?.captcha_detected != null ? String(result.raw_data.captcha_detected) : null },
        { key: "CALENDLY_FOUND", label: "Calendly Found",
          getValue: (result) => result.raw_data?.calendly_found != null ? String(result.raw_data.calendly_found) : null },
        { key: "GOOGLE_FORMS_FOUND", label: "Google Forms",
          getValue: (result) => result.raw_data?.google_forms_found != null ? String(result.raw_data.google_forms_found) : null },
        { key: "SOCIAL_COUNT", label: "Social Links",
          getValue: (result) => result.raw_data?.social_media ? String(result.raw_data.social_media.length) : null },

        // === per-platform flags ===
        { key: "HAS_FACEBOOK", label: "Has Facebook",
          getValue: (result) => result.raw_data?.social_media
            ? String(result.raw_data.social_media.some((s) => s.platform === "facebook"))
            : null },
        { key: "HAS_INSTAGRAM", label: "Has Instagram",
          getValue: (result) => result.raw_data?.social_media
            ? String(result.raw_data.social_media.some((s) => s.platform === "instagram"))
            : null },
        { key: "HAS_TWITTER", label: "Has Twitter",
          getValue: (result) => result.raw_data?.social_media
            ? String(result.raw_data.social_media.some((s) => s.platform === "twitter"))
            : null },
        { key: "HAS_LINKEDIN", label: "Has LinkedIn",
          getValue: (result) => result.raw_data?.social_media
            ? String(result.raw_data.social_media.some((s) => s.platform === "linkedin"))
            : null },
        { key: "HAS_YOUTUBE", label: "Has YouTube",
          getValue: (result) => result.raw_data?.social_media
            ? String(result.raw_data.social_media.some((s) => s.platform === "youtube"))
            : null },

        // === TEXT: 33% / 66% / full ===
        { key: "TEXT_33", label: "Text (33%)",
          getValue: (result) => {
            const txt = result.raw_data?.main_page_text || result.raw_data?.text || "";
            if (!txt) return null;
            return txt.slice(0, Math.floor(txt.length * 0.33));
          } },
        { key: "TEXT_66", label: "Text (66%)",
          getValue: (result) => {
            const txt = result.raw_data?.main_page_text || result.raw_data?.text || "";
            if (!txt) return null;
            return txt.slice(0, Math.floor(txt.length * 0.66));
          } },
        { key: "TEXT", label: "Full Text",
          getValue: (result) => result.raw_data?.main_page_text || result.raw_data?.text || null },
      ],

      basicFilters: [
        
        { key: "URL", label: "URL", type: "text" },
        { key: "TITLE", label: "Title", type: "text" },
        { key: "DESCRIPTION", label: "Description", type: "text" },
        { key: "TEXT", label: "Text", type: "text" },
 
        { key: "MATCHED_RULE", label: "Matched Rule", type: "text" },
       
        { key: "EMAIL", label: "Email", type: "text" },
         { key: "HAS_REDIRECT", label: "Has Redirect", type: "bool" },
        { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
        { key: "HAS_SPA", label: "Has SPA", type: "bool" },
        { key: "HAS_CONTACT_FORM", label: "Has Contact Form", type: "bool" },
        { key: "EMAIL_PROTECTED", label: "Email Protected", type: "bool" },
        { key: "CAPTCHA_DETECTED", label: "Captcha Detected", type: "bool" },
        { key: "CALENDLY_FOUND", label: "Calendly Found", type: "bool" },
        { key: "GOOGLE_FORMS_FOUND", label: "Google Forms Found", type: "bool" },
        { key: "HAS_FACEBOOK", label: "Has Facebook", type: "bool" },
        { key: "HAS_INSTAGRAM", label: "Has Instagram", type: "bool" },
        { key: "HAS_TWITTER", label: "Has Twitter", type: "bool" },
        { key: "HAS_LINKEDIN", label: "Has LinkedIn", type: "bool" },
        { key: "HAS_YOUTUBE", label: "Has YouTube", type: "bool" },
      ],

      sections: [
       
         // Profile Header — домен + финальный URL + статус
        {
          type: "profile_header",
          label: "Website",
          hideWhenEmpty: true,
          getValue: (result) => {
            const domain = result.raw_data?.dns?.domain
              || (result.url || "").replace(/^https?:\/\//, "").split("/")[0];
            if (!domain) return null;
            return {
              username: domain,
              url: result.raw_data?.final_url || result.url,
              full_name: result.raw_data?.title || domain,
              profile_pic_url: null,
              subtitle: result.status || null,
            };
          },
        },

        // Title
        {
          type: "text",
          key: "title",
          label: "Title",
          hideWhenEmpty: true,
          getValue: (result) => result.raw_data?.title || null,
          style: {
            fontSize: 14,
            lineHeight: 1.7,
            whiteSpace: "pre-wrap",
            maxHeight: 300,
            overflowY: "auto",
          },
        },

        // Description
        {
          type: "text",
          key: "description",
          label: "Description",
          hideWhenEmpty: true,
          getValue: (result) => result.raw_data?.description || null,
          style: {
            fontSize: 14,
            lineHeight: 1.7,
            whiteSpace: "pre-wrap",
            maxHeight: 300,
            overflowY: "auto",
          },
        },
        // Website Text — ссылка на S3
        {
          type: "custom",
          key: "main_page_text",
          label: "Website Text",
          hideWhenEmpty: true,
          render: (result) => {
            const key = result.raw_data?.main_page_text_key;
            const fallbackText = result.raw_data?.main_page_text || result.raw_data?.text;
            if (key) {
              const url = `https://s3.twcstorage.ru/1069577a-d68b-409d-9398-fef1c9cce817/${key}`;
              return (
                <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#1890ff',
                      textDecoration: 'none',
                      wordBreak: 'break-all',
                      display: 'inline-block',
                      padding: '6px 10px',
                      border: '1.5px solid #1890ff',
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    📄 Open Website Text
                  </a>
                </div>
              );
            }
            if (fallbackText) {
              return (
                <div style={{
                  fontSize: 13, lineHeight: 1.7, whiteSpace: "pre-wrap",
                  maxHeight: 400, overflowY: "auto",
                  background: "#fafafa", padding: "8px 12px", borderRadius: 8,
                }}>
                  {fallbackText}
                </div>
              );
            }
            return null;
          },
        },

        // Matched Rule
        {
          type: "text",
          key: "matched_rule",
          label: "Matched Rule",
          hideWhenEmpty: true,
          getValue: (result) => result.raw_data?.dns?.matched_rule || null,
          style: {
            fontSize: 14,
            lineHeight: 1.7,
            whiteSpace: "pre-wrap",
            background: "#f0fdf4",
            padding: "8px 12px",
            borderRadius: 8,
          },
        },

        // Emails
        {
          type: "custom",
          key: "emails",
          label: "Emails",
          hideWhenEmpty: true,
          render: (result) => {
            const emails = result.raw_data?.emails;
            if (!Array.isArray(emails) || emails.length === 0) return null;
            return (
              <div style={{ fontSize: 14, lineHeight: 1.7 }}>
                {emails.map((email, i) => (
                  <div key={i} style={{ marginBottom: 6 }}>
                    <a
                      href={`mailto:${email}`}
                      style={{ color: '#1890ff', textDecoration: 'none' }}
                    >
                      ✉️ {email}
                    </a>
                  </div>
                ))}
              </div>
            );
          },
        },

        // Social Media
        {
          type: "custom",
          key: "social_media",
          label: "Social Media",
          hideWhenEmpty: true,
          render: (result) => {
            const socials = result.raw_data?.social_media;
            if (!Array.isArray(socials) || socials.length === 0) return null;

            const grouped = {};
            socials.forEach((s) => {
              if (!grouped[s.platform]) grouped[s.platform] = new Set();
              grouped[s.platform].add(s.url);
            });

            const icons = {
              facebook: "📘",
              instagram: "📷",
              twitter: "🐦",
              linkedin: "💼",
              youtube: "▶️",
            };

            return (
              <div style={{ fontSize: 14, lineHeight: 1.7 }}>
                {Object.entries(grouped).map(([platform, urls]) => (
                  <div key={platform} style={{ marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                      {icons[platform] || "🔗"} {platform} ({urls.size})
                    </div>
                    {[...urls].map((url, i) => (
                      <div key={i} style={{ marginLeft: 16, marginBottom: 2 }}>
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: '#1890ff',
                            textDecoration: 'none',
                            wordBreak: 'break-all',
                          }}
                        >
                          {url}
                        </a>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            );
          },
        },

        // Detection Flags
        {
          type: "custom",
          key: "flags",
          label: "Detection Flags",
          hideWhenEmpty: true,
          render: (result) => {
            const r = result.raw_data || {};
            const emails = Array.isArray(r.emails) ? r.emails : [];
            const socials = Array.isArray(r.social_media) ? r.social_media : [];
            const hasPlatform = (p) => socials.some((s) => s.platform === p);

            const flags = [
              { label: "Has Email", value: emails.length > 0, icon: "✉️" },
              { label: "SPA", value: r.has_spa, icon: "⚡" },
              { label: "Contact Form", value: r.has_contact_form, icon: "📝" },
              { label: "Email Protected", value: r.email_protected, icon: "🔒" },
              { label: "Captcha Detected", value: r.captcha_detected, icon: "🤖" },
              { label: "Calendly Found", value: r.calendly_found, icon: "📅" },
              { label: "Google Forms", value: r.google_forms_found, icon: "📋" },
              { label: "Facebook", value: hasPlatform("facebook"), icon: "📘" },
              { label: "Instagram", value: hasPlatform("instagram"), icon: "📷" },
              { label: "Twitter", value: hasPlatform("twitter"), icon: "🐦" },
              { label: "LinkedIn", value: hasPlatform("linkedin"), icon: "💼" },
              { label: "YouTube", value: hasPlatform("youtube"), icon: "▶️" },
            ].filter((f) => f.value !== undefined && f.value !== null);

            if (flags.length === 0) return null;

            return (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {flags.map((f) => (
                  <span
                    key={f.label}
                    style={{
                      padding: '4px 10px',
                      borderRadius: 12,
                      fontSize: 12,
                      background: f.value ? '#dcfce7' : '#f3f4f6',
                      color: f.value ? '#166534' : '#6b7280',
                      border: `1px solid ${f.value ? '#86efac' : '#e5e7eb'}`,
                    }}
                  >
                    {f.icon} {f.label}: {f.value ? "Yes" : "No"}
                  </span>
                ))}
              </div>
            );
          },
        },

        // Captcha Types
        {
          type: "text",
          key: "captcha_types",
          label: "Captcha Types",
          hideWhenEmpty: true,
          getValue: (result) => {
            const types = result.raw_data?.captcha_types;
            return Array.isArray(types) && types.length ? types.join(", ") : null;
          },
          style: { fontSize: 14, lineHeight: 1.7 },
        },

        // SPA Reasons
        {
          type: "text",
          key: "spa_reasons",
          label: "SPA Reasons",
          hideWhenEmpty: true,
          getValue: (result) => {
            const reasons = result.raw_data?.spa_reasons;
            return Array.isArray(reasons) && reasons.length ? reasons.join(", ") : null;
          },
          style: { fontSize: 14, lineHeight: 1.7 },
        },

        // Fetch Errors
        {
          type: "text",
          key: "fetch_errors",
          label: "Fetch Errors",
          hideWhenEmpty: true,
          getValue: (result) => {
            const errs = result.raw_data?.fetch_errors;
            return Array.isArray(errs) && errs.length ? errs.join("\n") : null;
          },
          style: { fontSize: 13, lineHeight: 1.6, color: "#b91c1c", whiteSpace: "pre-wrap" },
        },

        // Website Text (полный)
        {
          type: "text",
          key: "main_page_text",
          label: "Website Text",
          hideWhenEmpty: true,
          getValue: (result) => result.raw_data?.main_page_text || result.raw_data?.text || null,
          style: {
            fontSize: 13,
            lineHeight: 1.7,
            whiteSpace: "pre-wrap",
            maxHeight: 400,
            overflowY: "auto",
            background: "#fafafa",
            padding: "8px 12px",
            borderRadius: 8,
          },
        },

        // Checked Pages
        {
          type: "custom",
          key: "checked_pages",
          label: "Checked Pages",
          hideWhenEmpty: true,
          render: (result) => {
            const pages = result.raw_data?.checked_pages;
            if (!Array.isArray(pages) || pages.length === 0) return null;
            return (
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                {pages.map((p, i) => (
                  <div key={i} style={{ marginBottom: 2 }}>
                    <a href={p} target="_blank" rel="noopener noreferrer"
                       style={{ color: '#1890ff', textDecoration: 'none', wordBreak: 'break-all' }}>
                      🔍 {p}
                    </a>
                  </div>
                ))}
              </div>
            );
          },
        },

        // Details
        {
          type: "meta",
          label: "Details",
          hideWhenEmpty: true,
          items: [
            { key: "worker", label: "Worker", getValue: (r) => r.raw_data?.worker, icon: "⚙️" },
            { key: "root_url", label: "Root URL", getValue: (r) => r.raw_data?.root_url, isLink: true, icon: "🔗" },
            { key: "final_url", label: "Final URL", getValue: (r) => r.raw_data?.final_url, isLink: true, icon: "🔗" },
            { key: "timestamp", label: "Scraped At", getValue: (r) => r.raw_data?.timestamp ? formatDate(r.raw_data.timestamp) : null, icon: "🕒" },
            { key: "url", label: "URL", getValue: (r) => r.url, isLink: true, icon: "🌐" },
            { key: "created_at", label: "Added", getValue: (r) => formatDate(r.created_at), icon: "📅" },
          ],
        },

        // Source
        {
          type: "meta",
          label: "Source",
          hideWhenEmpty: true,
          items: [
            { key: "scraped_url", label: "Scraped URL", getValue: (r) => r.source?.scraped_url, isLink: true, icon: "🔍" },
            { key: "keyword", label: "Keyword", getValue: (r) => r.source?.keyword, icon: "🔑" },
            { key: "search_position", label: "Position", getValue: (r) => r.source?.search_position, icon: "📍" },
            { key: "search_page", label: "Search Page", getValue: (r) => r.source?.search_page, icon: "📄" },
          ],
        },
      ],
    },



    default: {
      title: t.visualizationTemplate.result,
      aiVariables: [
        { key: "RAW_DATA", label: t.visualizationTemplate.rawJson, getValue: (result) => JSON.stringify(result, null, 2) },
      ],
      sections: [
        { type: "json", label: t.visualizationTemplate.rawData, getValue: (result) => result }
      ]
    }
  };
}

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) +
    " " + d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
}

export function getTemplate(subtype, lang) {
  const templates = getVisualizationTemplates(lang);
  return templates[subtype] || templates.default;
}